var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonAnimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-lesson",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-lesson:not(.animated) .animable {opacity: 0;}svg#freepik_stories-lesson.animated #freepik--Floor--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--Blackboard--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--Shadows--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--Plant--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--Books--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--character-2--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--character-1--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--speech-bubble--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-lesson.animated #freepik--paper-planes--inject-84 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}            @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-84",
    className: "animable",
    style: {
      transformOrigin: "250.002px 358.75px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-84",
    d: "M91.57,267.28C4.08,317.8,4.08,399.7,91.58,450.22s229.35,50.51,316.85,0,87.49-132.42,0-182.94S179.07,216.77,91.57,267.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.002px 358.75px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-84",
    className: "animable",
    style: {
      transformOrigin: "124.18px 144.07px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-84",
    className: "animable",
    style: {
      transformOrigin: "124.18px 144.07px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "221.18 166.01 37.21 272.17 37.21 270.41 221.18 164.25 221.18 166.01",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "129.195px 218.21px"
    },
    id: "ele9brzq9ryzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.51 160.98 221.18 164.25 37.21 270.41 31.54 267.14 215.51 160.98",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "126.36px 215.695px"
    },
    id: "elabbw1khjmp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.54 267.14 37.21 270.41 37.21 272.17 31.54 268.9 31.54 267.14",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "34.375px 269.655px"
    },
    id: "el91r892lwx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.51 160.98 31.54 267.14 31.54 124.64 215.51 18.49 215.51 160.98",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "123.525px 142.815px"
    },
    id: "el59lls13os87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.55 257.57 36.55 128.43 210.5 28.05 210.5 157.2 36.55 257.57",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "123.525px 142.81px"
    },
    id: "elajbob15bzx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elluxegs2qccm"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.54 253.88 36.54 257.56 210.5 157.2 210.5 28.04 207.28 29.91 207.28 155.35 36.54 253.88",
    style: {
      opacity: 0.1,
      transformOrigin: "123.52px 142.8px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "27.18 122.12 31.54 124.64 31.54 267.14 27.18 264.62 27.18 122.12",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "29.36px 194.63px"
    },
    id: "el0851nsyu18rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.51 18.49 211.15 15.97 27.18 122.12 31.54 124.64 215.51 18.49",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "121.345px 70.305px"
    },
    id: "elw6vt2kk8f5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,159.81c-.73-.41,8.33-14.87,9-15.94,2-3.38,8.48-3.26,9.17,1.2a41.82,41.82,0,0,1-.15,12.6c5.16-11.94,9.32-24.44,16.1-35.54,2.37-3.88,10-2.69,9.35,2.54-1.6,12.73-5,25-8.82,37.07,7.24-19.43,12.19-39.93,16-59.47,1.09-5.54,10.09-4.29,9.85,1.34a240.44,240.44,0,0,1-4.09,35.08c1.73-4.33,3.4-8.69,5-13.07,2.25-5.94,11.22-3.72,9.67,2.67-.58,2.42-1.17,4.85-1.76,7.27,2.37-5.55,4.69-11.13,6.91-16.75,1.87-4.73,10.67-4.76,9.85,1.34-.06.44-.14.88-.2,1.33h0a.36.36,0,0,1,0,.09c-.31,2.18-.68,4.35-1.09,6.5,2.71-6.7,5.24-13.46,7.64-20.28,2.76-7.82,4.39-17.21,9-24.13a5.08,5.08,0,0,1,8.66,0c4.05,6.39,1.62,13.72.1,20.69a284.72,284.72,0,0,1-8.44,30.07c-1.49,4.42-3.07,8.8-4.71,13.16,2.62-4.2,5.15-8.47,7.53-12.82,9.59-17.5,13.94-36.78,22.53-54.63,2.18-4.52,9.52-2.28,9.34,2.53-.52,14.65-4.32,28.46-9.78,42-1.87,4.64-3.89,9.23-5.93,13.8q9.25-13.32,17.61-27.27c2.06-3.42,8.39-3.23,9.17,1.2a54.87,54.87,0,0,1-1.14,25.19c-1.75,6.2-11.43,3.57-9.67-2.67.34-1.21.62-2.39.87-3.57A501.16,501.16,0,0,1,160.35,173c-2.7,3.34-8.85.61-8.56-3.54a44.88,44.88,0,0,1,1.45-8.29c-6.64,10-13.72,19.6-20.8,29.23-3.86,5.25-11.22.87-8.66-5.06,4.13-9.57,8.22-19.16,12.11-28.84a242.74,242.74,0,0,1-21.15,34.56c-3.82,5.16-11.45.85-8.66-5.07,1.51-3.19,3-6.4,4.5-9.61a5.12,5.12,0,0,1-6.77-2.57c-1.73,3-3.52,5.92-5.47,8.78a4.89,4.89,0,0,1-8.48-.09,171.24,171.24,0,0,1-17.41,29.71c-3.32,4.49-10.38,2-9.16-3.86a282.41,282.41,0,0,1,9-31.41,85.39,85.39,0,0,1-6.84,10.25c-2.82,3.59-8.51.42-8.56-3.55-.07-5.66,1.34-11.26,2.67-16.84-3.17,3-7,4.25-11.59,1.64C42.34,165.3,47.39,156.63,53,159.81Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "123.487px 146.095px"
    },
    id: "elrky7ne2t5so",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.08,240.15a3.66,3.66,0,0,0-1.65-2.86,1.16,1.16,0,0,0-1.16-.11h0L60.65,247.93,63,252,81.6,241.21h0A1.14,1.14,0,0,0,82.08,240.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "71.3685px 244.537px"
    },
    id: "elpxv2knax4hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.81,248a3.66,3.66,0,0,1,1.65,2.86c0,1-.74,1.47-1.65.95A3.65,3.65,0,0,1,60.17,249C60.17,247.94,60.9,247.52,61.81,248Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "61.815px 249.913px"
    },
    id: "elx6t272lji2",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-84",
    className: "animable",
    style: {
      transformOrigin: "254.642px 382.53px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-84",
    d: "M274.52,304.14c12.93,7.55,12.93,19.8,0,27.35s-33.91,7.55-46.84,0-12.94-19.8,0-27.35S261.58,296.59,274.52,304.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.098px 317.815px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-84",
    cx: 102.21,
    cy: 404.23,
    rx: 67.03,
    ry: 38.7,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "102.21px 404.23px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-84",
    points: "183.05 412.07 247.04 375.12 163.06 326.63 99.07 363.58 183.05 412.07",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "173.055px 369.35px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-84",
    d: "M219.8,391.21l130,75.17a1.91,1.91,0,0,0,1.71,0l81.91-47.32c.48-.28.48-.72,0-1l-130-75.17a1.91,1.91,0,0,0-1.71,0L219.8,390.22C219.32,390.5,219.32,390.94,219.8,391.21Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "326.61px 404.635px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-84",
    d: "M388.61,422.73,472.83,375c1.69-1,1.71-2.53,0-3.52l-81.79-47.95a6.73,6.73,0,0,0-6.1-.05l-84.23,47.78c-1.69,1-1.7,2.54,0,3.52l81.79,48A6.76,6.76,0,0,0,388.61,422.73Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "386.772px 373.129px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-84",
    className: "animable",
    style: {
      transformOrigin: "250px 249.784px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-84",
    className: "animable",
    style: {
      transformOrigin: "250px 249.784px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-84",
    className: "animable",
    style: {
      transformOrigin: "250px 249.784px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-84",
    className: "animable",
    style: {
      transformOrigin: "251.09px 293.294px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.32,319.87c-11.12-11.47-17.64-42.26-6.8-51.35h55.14c10.84,9.09,4.32,39.87-6.79,51.34-.09.11-.2.21-.3.31l-.38.38c-.32.31-.65.61-1,.91l-.26.21c-.27.21-.54.43-.84.64a16,16,0,0,1-1.44.93c-9.14,5.33-24,5.33-33.1,0h0c-.49-.28-1-.6-1.45-.94-.27-.19-.52-.39-.78-.6a3.75,3.75,0,0,1-.33-.26q-.51-.42-1-.87l-.45-.43Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "251.09px 297.879px"
    },
    id: "elsdtsk2lalca",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.88,264.86c12.58,7.34,12.58,19.25,0,26.6s-33,7.35-45.57,0-12.59-19.26,0-26.6S261.29,257.51,273.88,264.86Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "251.095px 278.162px"
    },
    id: "elb7tod495bxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.82,268.39c9.24,5.39,9.24,14.14,0,19.54s-24.22,5.39-33.46,0-9.24-14.15,0-19.54S258.58,263,267.82,268.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.09px 278.162px"
    },
    id: "el1k3jb6hi61o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36,277.66c9.24-5.39,24.22-5.39,33.46,0a15.43,15.43,0,0,1,5.54,5.13,15.36,15.36,0,0,1-5.54,5.14c-9.24,5.39-24.22,5.39-33.46,0a15.44,15.44,0,0,1-5.54-5.14A15.51,15.51,0,0,1,234.36,277.66Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "251.09px 282.795px"
    },
    id: "elmklql1i9d18",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-84",
    className: "animable",
    style: {
      transformOrigin: "250px 229.109px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.4,192.58l-12.94,16.94,13.83-11.2a44.88,44.88,0,0,1,1,15.53,98.84,98.84,0,0,0-10,11.73l10.81-7.78s2.83,7.7,2.59,20.61c-.06,3.38-2.08,10.31-3.18,15.39a54.94,54.94,0,0,1-2,6.91l-.15.43q-4.73-1.32-9.72-2.4c-3-3.57-8-13-11-20.94-11.42-30.56,7.78-54.59,25.36-65.47C263.07,172.33,258.59,182.23,258.4,192.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "248.951px 216.735px"
    },
    id: "elf9gzqfsqf6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.19,197.32c-2.46,4.16-3.29,9-3.67,13.78a65.45,65.45,0,0,0,.58,14.33,60.72,60.72,0,0,0,10.34,26.42h0a.47.47,0,1,1-.76.54h0a61.47,61.47,0,0,1-10-26.9,66.16,66.16,0,0,1-.34-14.41C241.74,206.32,242.66,201.44,245.19,197.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "246.831px 224.979px"
    },
    id: "elr315n40221a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.93,212.45l0,0c.41.55,7.18,9.63,17,27.09l17.81,3.93-13.39,1.55,6.47,11.7,17.48,4.68-14,1.45s3.06,13.71,12.63,19.9c5.28,3.42,7.64,3.63,9.65,2.58,2.45-1.27,3.8-5.08,5.09-10.8s0-17.49-4.83-29.13a35.62,35.62,0,0,0-5.19-8.66C231.5,221.44,207.17,213,194.93,212.45Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "224.535px 249.169px"
    },
    id: "elnpwmzeaxag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.4,219.42c9.07,4.62,17.54,10.73,24,18.73a49.37,49.37,0,0,1,7.83,13.21,46.57,46.57,0,0,1,3.05,15,0,0,0,0,1,0,.05.07.07,0,0,1-.06,0,59.45,59.45,0,0,0-3.88-14.64,55.23,55.23,0,0,0-7.53-13.09c-6.24-8-14.52-14.26-23.43-19.13a0,0,0,0,1,0-.07A0,0,0,0,1,213.4,219.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "230.83px 242.918px"
    },
    id: "elucq80smrc1p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.07,205.52h0a42.8,42.8,0,0,0-5.28.87,85.36,85.36,0,0,0-19.72,7.34c-2.32,1.19-4.64,2.5-6.9,3.92-1.12.72-2.24,1.46-3.33,2.23a59.28,59.28,0,0,0-14.18,13.6,37.43,37.43,0,0,0-4.46,8.15c-.15.38-.31.75-.45,1.12h0c-.34,1-.64,1.94-.92,2.89-3.29,10.67-2.84,17.75-1.64,25.53.94,6,3.81,12.7,5.13,13.7a2.72,2.72,0,0,0,.57.33c1.85.9,4.52-.07,9.32-3.54,9.6-7,11.92-22,11.92-22l-14.58-.74,17.92-5.83,6.08-12.51-14-.87,18.3-5.07c9.26-18.69,15.81-28.49,16.2-29.09l0,0Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "276.183px 245.518px"
    },
    id: "elwwyv0o5tnv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.79,206.39a85.36,85.36,0,0,0-19.72,7.34c-2.32,1.19-4.64,2.5-6.9,3.92-1.12.72-2.24,1.46-3.33,2.23a59.28,59.28,0,0,0-14.18,13.6,37.43,37.43,0,0,0-4.46,8.15c-.15.38-.31.75-.45,1.12h0c-.34,1-.64,1.94-.92,2.89-3.29,10.67-2.84,17.75-1.64,25.53.94,6,3.81,12.7,5.13,13.7a2.72,2.72,0,0,0,.57.33,3.24,3.24,0,0,0,1.18.28c-2.37-9.24-.57-33.58,5.27-44.2,6.07-11,21.59-27.85,44.7-35.74l0,0A43.91,43.91,0,0,0,299.79,206.39Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "276.168px 245.51px"
    },
    id: "elisugwqyy1nc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,285.5a81.44,81.44,0,0,1-1.1-20.92,67.49,67.49,0,0,1,4.57-20.5c2.79-6.54,7.25-12.14,12.1-17.21A78.53,78.53,0,0,1,287.2,214a.07.07,0,0,1,.08,0s0,.05,0,.07a103.7,103.7,0,0,0-15.84,13.55,76.83,76.83,0,0,0-6.72,7.92,46,46,0,0,0-5.36,8.85,66.64,66.64,0,0,0-4.84,20.17,80.45,80.45,0,0,0,.63,20.85.08.08,0,0,1,0,.07S255,285.53,255,285.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "270.471px 249.749px"
    },
    id: "ellxb0hzktwoj",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-84",
    className: "animable",
    style: {
      transformOrigin: "174.57px 313.599px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Book--inject-84",
    className: "animable",
    style: {
      transformOrigin: "190.46px 304.024px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.27,258.63v2.8s-1.08-1-1.14-1.69S231.27,258.63,231.27,258.63Z",
    id: "elmci23helim",
    className: "animable",
    style: {
      transformOrigin: "230.699px 260.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.12,258a2.93,2.93,0,0,0,2.16,3.74c3.05,1,5,0,5.42.86S222.22,272,222.22,272l2.84-12.36Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "229.464px 265px"
    },
    id: "elp117lvsap58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8qn9c9dufx9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.12,258a2.93,2.93,0,0,0,2.16,3.74c3.05,1,5,0,5.42.86S222.22,272,222.22,272l2.84-12.36Z",
    style: {
      opacity: 0.3,
      transformOrigin: "229.464px 265px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.48,373.61v.17l-1.5-.86-64.09-37,5.64-111.11c0-1.78,1-2.67,2.19-2l2.18,1.27,59.93,34.58-.06.53Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "192.86px 298.184px"
    },
    id: "elae41069p1w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elazpjv5mvg4h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.48,373.61v.17l-1.5-.86-64.09-37,5.64-111.11c0-1.78,1-2.67,2.19-2l2.18,1.27,59.93,34.58-.06.53Z",
    style: {
      opacity: 0.2,
      transformOrigin: "192.86px 298.184px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.77,275.45l-3.14-3.54,16.09-9.29c2.43,1.83,4.29,2.81,6.46,1.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "222.905px 269.035px"
    },
    id: "elnlt5bdhdu5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,260.72l-59.35-34.27a4.15,4.15,0,0,0-3.73,0L148,235.61l60.2,34.45a5.5,5.5,0,0,1,4.37.75c1.77,1.44,1.67-.38,1.67-.38l13.53-7.81C226.61,261.14,226.9,260.72,226.9,260.72Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "187.885px 248.686px"
    },
    id: "elwz7b65s9jl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.61,274.71c-.61-.35-.87-.76-.58-.93l.5-.29c.56-.32,0-1.15-1.17-1.86s-2.65-1-3.21-.68l-.5.29a4,4,0,0,1-2.37-.77l.37,111.3,1.5.86a1.35,1.35,0,0,0,.87-.08l.51-.29c.55-.32,2,0,3.19.68s1.74,1.53,1.18,1.86l-.51.29c-.28.16,0,.57.59.93Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "210.2px 328.245px"
    },
    id: "eleuhkwllfga9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo5eq9sau31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.61,274.71c-.61-.35-.87-.76-.58-.93l.5-.29c.56-.32,0-1.15-1.17-1.86s-2.65-1-3.21-.68l-.5.29a4,4,0,0,1-2.37-.77l.37,111.3,1.5.86a1.35,1.35,0,0,0,.87-.08l.51-.29c.55-.32,2,0,3.19.68s1.74,1.53,1.18,1.86l-.51.29c-.28.16,0,.57.59.93Z",
    style: {
      opacity: 0.4,
      transformOrigin: "210.2px 328.245px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.15,382.46v.17l-1.5-.86-64.1-37V236.91c0-1.79,1-2.67,2.18-2l2.19,1.27,61.22,33.85Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "175.35px 308.658px"
    },
    id: "elr7gv4atksc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elor9ajqjc6p9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.15,382.46v.17l-1.5-.86-64.1-37V236.91c0-1.79,1-2.67,2.18-2l2.19,1.27,61.22,33.85Z",
    style: {
      opacity: 0.2,
      transformOrigin: "175.35px 308.658px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,385.39V274l4,1.61V386.63a3.77,3.77,0,0,1-2.2-.22Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "214.91px 330.352px"
    },
    id: "eldfcod5pqh4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6vc5ijlhlm3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.91,385.39V274l4,1.61V386.63a3.77,3.77,0,0,1-2.2-.22Z",
    style: {
      opacity: 0.2,
      transformOrigin: "214.91px 330.352px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.31,373.83a1.49,1.49,0,0,1,0,.21.35.35,0,0,1,0,.14,1.14,1.14,0,0,1-.13.3.41.41,0,0,1-.07.15,2.69,2.69,0,0,1-.34.49c-.13.16-.29.32-.45.48s-.36.32-.56.48a2.42,2.42,0,0,1-.36.27l-.29.21c-.22.15-.46.3-.71.45l-13.81,8a13,13,0,0,1-4.65,1.65V275.57l21.43-12.84v111.1Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "227.655px 324.695px"
    },
    id: "elp8zfnrlcne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,291v13.39c8.57-2.9,15.91-6.85,21.43-12.37V278.61C232.8,284.13,225.46,288.08,216.89,291Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "227.605px 291.5px"
    },
    id: "elqplf1fae24b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,291v13.39c8.57-2.9,15.91-6.85,21.43-12.37V278.61C232.8,284.13,225.46,288.08,216.89,291Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "227.605px 291.5px"
    },
    id: "elpw1yjwl4da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,309.34v5c8.57-2.91,15.91-6.86,21.43-12.37v-5C232.8,302.48,225.46,306.43,216.89,309.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "227.605px 305.655px"
    },
    id: "elh4vllru96t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.89,309.34v5c8.57-2.91,15.91-6.86,21.43-12.37v-5C232.8,302.48,225.46,306.43,216.89,309.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "227.605px 305.655px"
    },
    id: "eldllgze5scir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.55,273.91,220.47,272a9.78,9.78,0,0,1-4.59,1.45,2.89,2.89,0,0,0-.38-1.82,5.59,5.59,0,0,0-2.07-1.9,8.11,8.11,0,0,0-3.14-1.06l-.23,0a3.54,3.54,0,0,0-1.92.36L151.3,236.23l-1.94-1.11-2.46-1.42a1.29,1.29,0,0,0-1.34-.1l-2.18,1.26a1.33,1.33,0,0,1,1.37.08l0,0,6.52,3.77,55,31.74a4.06,4.06,0,0,0,2.37.78l.51-.29a1.75,1.75,0,0,1,1.13-.08,6.21,6.21,0,0,1,2.07.75c1.21.7,1.73,1.54,1.17,1.86l-.5.29c-.29.17,0,.58.58.93l1.09.62C215.9,276,219,275.39,221.55,273.91Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "182.465px 254.526px"
    },
    id: "eldip1wtyszv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgwt9taqadn7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.55,273.91,220.47,272a9.78,9.78,0,0,1-4.59,1.45,2.89,2.89,0,0,0-.38-1.82,5.59,5.59,0,0,0-2.07-1.9,8.11,8.11,0,0,0-3.14-1.06l-.23,0a3.54,3.54,0,0,0-1.92.36L151.3,236.23l-1.94-1.11-2.46-1.42a1.29,1.29,0,0,0-1.34-.1l-2.18,1.26a1.33,1.33,0,0,1,1.37.08l0,0,6.52,3.77,55,31.74a4.06,4.06,0,0,0,2.37.78l.51-.29a1.75,1.75,0,0,1,1.13-.08,6.21,6.21,0,0,1,2.07.75c1.21.7,1.73,1.54,1.17,1.86l-.5.29c-.29.17,0,.58.58.93l1.09.62C215.9,276,219,275.39,221.55,273.91Z",
    style: {
      opacity: 0.3,
      transformOrigin: "182.465px 254.526px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.47,272l13.81-8,.57-.35.44-.32,0,0c-1.58.69-3.72,0-5.13-.79a5.44,5.44,0,0,1-2-1.86,2.9,2.9,0,0,1-.34-2l-.19-.11-.39-.21-55-31.74-3.15-1.82-.91-.52-2.66-1.54a1.25,1.25,0,0,0-1.19,0l.59-.35,1.59-.91a1.2,1.2,0,0,1,1.11,0s0,0,0,0l1,.56.62.35c.36.22.72.42,1.06.61l.65.38.47.27.81.46,43.66,25.22,13.94,8c1,.57,1.58,1.16,1.35,1.36l-.08.06-.49.28c-.61.35-.12,1.2,1.09,1.9a2.93,2.93,0,0,0,2.76.39l.6-.35a1.07,1.07,0,0,1,.87-.13l.32.19.69.4.85.49a.86.86,0,0,1,.46,1,.24.24,0,0,1,0,.14,1.11,1.11,0,0,1-.12.3h0a.69.69,0,0,1-.07.15,2.54,2.54,0,0,1-.34.49,6.39,6.39,0,0,1-.44.48c-.18.16-.36.32-.57.48a2.33,2.33,0,0,1-.35.27l-.29.21c-.23.15-.46.3-.71.44l-13.81,8Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "201.305px 247.612px"
    },
    id: "elnzyglz9bof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyqfdta27nce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.47,272l13.81-8,.57-.35.44-.32,0,0c-1.58.69-3.72,0-5.13-.79a5.44,5.44,0,0,1-2-1.86,2.9,2.9,0,0,1-.34-2l-.19-.11-.39-.21-55-31.74-3.15-1.82-.91-.52-2.66-1.54a1.25,1.25,0,0,0-1.19,0l.59-.35,1.59-.91a1.2,1.2,0,0,1,1.11,0s0,0,0,0l1,.56.62.35c.36.22.72.42,1.06.61l.65.38.47.27.81.46,43.66,25.22,13.94,8c1,.57,1.58,1.16,1.35,1.36l-.08.06-.49.28c-.61.35-.12,1.2,1.09,1.9a2.93,2.93,0,0,0,2.76.39l.6-.35a1.07,1.07,0,0,1,.87-.13l.32.19.69.4.85.49a.86.86,0,0,1,.46,1,.24.24,0,0,1,0,.14,1.11,1.11,0,0,1-.12.3h0a.69.69,0,0,1-.07.15,2.54,2.54,0,0,1-.34.49,6.39,6.39,0,0,1-.44.48c-.18.16-.36.32-.57.48a2.33,2.33,0,0,1-.35.27l-.29.21c-.23.15-.46.3-.71.44l-13.81,8Z",
    style: {
      opacity: 0.3,
      transformOrigin: "201.305px 247.612px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book--inject-84",
    className: "animable",
    style: {
      transformOrigin: "158.68px 323.192px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.49,277.78v2.8s-1.08-1-1.14-1.69S199.49,277.78,199.49,277.78Z",
    id: "elm35fg1dpeb",
    className: "animable",
    style: {
      transformOrigin: "198.919px 279.18px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,277.1a2.93,2.93,0,0,0,2.16,3.74c3.05,1,5,0,5.42.86s-14.48,9.47-14.48,9.47l2.84-12.37Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "197.684px 284.135px"
    },
    id: "ellqdht3bzjia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr5h7d1kw6pa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.34,277.1a2.93,2.93,0,0,0,2.16,3.74c3.05,1,5,0,5.42.86s-14.48,9.47-14.48,9.47l2.84-12.37Z",
    style: {
      opacity: 0.3,
      transformOrigin: "197.684px 284.135px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,392.75v.18l-1.5-.86-64.09-37L131.75,244c0-1.79,1-2.67,2.19-2l2.18,1.27,59.93,34.58-.06.53Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "161.08px 317.353px"
    },
    id: "ele3xgpdjh4ap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhff0hjied66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7,392.75v.18l-1.5-.86-64.09-37L131.75,244c0-1.79,1-2.67,2.19-2l2.18,1.27,59.93,34.58-.06.53Z",
    style: {
      opacity: 0.2,
      transformOrigin: "161.08px 317.353px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183,294.6l-3.14-3.54,16.09-9.29c2.43,1.83,4.29,2.81,6.46,1.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "191.135px 288.185px"
    },
    id: "el75umccfbkhp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.12,279.87,135.77,245.6a4.15,4.15,0,0,0-3.73,0l-15.86,9.16,60.19,34.45a5.5,5.5,0,0,1,4.37.75c1.77,1.43,1.67-.38,1.67-.38l13.53-7.81C194.83,280.29,195.12,279.87,195.12,279.87Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "156.06px 267.834px"
    },
    id: "elq55ni5e43",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.83,293.86c-.61-.35-.87-.76-.58-.93l.5-.29c.56-.32,0-1.15-1.17-1.86s-2.65-1-3.21-.69l-.5.3a4,4,0,0,1-2.37-.77l.37,111.3,1.5.86a1.35,1.35,0,0,0,.87-.08l.51-.29c.56-.32,2,0,3.2.68s1.73,1.53,1.17,1.85l-.51.29c-.28.17,0,.58.59.93Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "178.422px 347.39px"
    },
    id: "elgyw95k0k1s6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elklvdohpx01r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.83,293.86c-.61-.35-.87-.76-.58-.93l.5-.29c.56-.32,0-1.15-1.17-1.86s-2.65-1-3.21-.69l-.5.3a4,4,0,0,1-2.37-.77l.37,111.3,1.5.86a1.35,1.35,0,0,0,.87-.08l.51-.29c.56-.32,2,0,3.2.68s1.73,1.53,1.17,1.85l-.51.29c-.28.17,0,.58.59.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.25,
      transformOrigin: "178.422px 347.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176.37,401.61v.17l-1.5-.86-64.1-37V256.05c0-1.78,1-2.66,2.18-2l2.19,1.26,61.22,33.86Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "143.57px 327.806px"
    },
    id: "ely1j009y0kjr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcwgnkbgs04f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.37,401.61v.17l-1.5-.86-64.1-37V256.05c0-1.78,1-2.66,2.18-2l2.19,1.26,61.22,33.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "143.57px 327.806px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181.13,404.53V293.11l4,1.6V405.78a3.77,3.77,0,0,1-2.2-.22Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "183.13px 349.482px"
    },
    id: "elbejq3ql1l3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el66vgessakc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.13,404.53V293.11l4,1.6V405.78a3.77,3.77,0,0,1-2.2-.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "183.13px 349.482px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,393a1.49,1.49,0,0,1,0,.21.35.35,0,0,1,0,.14,1.3,1.3,0,0,1-.13.3.41.41,0,0,1-.07.15,3.08,3.08,0,0,1-.34.49c-.13.16-.29.32-.45.48s-.36.32-.56.48a2.42,2.42,0,0,1-.36.27l-.29.21c-.22.15-.46.3-.71.44l-13.81,8a13,13,0,0,1-4.65,1.66V294.71l21.43-12.84V393Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "195.875px 343.85px"
    },
    id: "el75e9i7dzij6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb3qzsdn8p2c"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "195.875px 343.85px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.53,393a1.49,1.49,0,0,1,0,.21.35.35,0,0,1,0,.14,1.3,1.3,0,0,1-.13.3.41.41,0,0,1-.07.15,3.08,3.08,0,0,1-.34.49c-.13.16-.29.32-.45.48s-.36.32-.56.48a2.42,2.42,0,0,1-.36.27l-.29.21c-.22.15-.46.3-.71.44l-13.81,8a13,13,0,0,1-4.65,1.66V294.71l21.43-12.84V393Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "195.875px 343.85px"
    },
    id: "elj8z6jacpohd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185.11,303.92v13.39c8.57-2.91,15.91-6.86,21.43-12.37V291.55C201,297.06,193.68,301,185.11,303.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "195.825px 304.43px"
    },
    id: "elvhyrrqe0ggi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.11,378.5v13.39c8.57-2.9,15.91-6.85,21.43-12.37V366.13C201,371.65,193.68,375.59,185.11,378.5Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "195.825px 379.01px"
    },
    id: "elp7mpos0vf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.77,293.05l-1.08-1.86a9.78,9.78,0,0,1-4.59,1.45,2.86,2.86,0,0,0-.38-1.82,5.59,5.59,0,0,0-2.07-1.9,8.13,8.13,0,0,0-3.14-1.07h-.23a3.49,3.49,0,0,0-1.91.36l-56.85-32.82-1.94-1.11-2.46-1.42a1.29,1.29,0,0,0-1.34-.1L111.6,254a1.33,1.33,0,0,1,1.37.08l0,0,6.52,3.77,55,31.73c1,.59,2.08.95,2.37.78l.51-.29a1.78,1.78,0,0,1,1.14-.07,6.24,6.24,0,0,1,2.06.75c1.21.7,1.73,1.54,1.17,1.86l-.5.29c-.29.17,0,.57.58.93l1.1.62C184.12,295.18,187.2,294.54,189.77,293.05Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "150.685px 273.685px"
    },
    id: "el3d26gce54pk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhprqm7s6kn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.77,293.05l-1.08-1.86a9.78,9.78,0,0,1-4.59,1.45,2.86,2.86,0,0,0-.38-1.82,5.59,5.59,0,0,0-2.07-1.9,8.13,8.13,0,0,0-3.14-1.07h-.23a3.49,3.49,0,0,0-1.91.36l-56.85-32.82-1.94-1.11-2.46-1.42a1.29,1.29,0,0,0-1.34-.1L111.6,254a1.33,1.33,0,0,1,1.37.08l0,0,6.52,3.77,55,31.73c1,.59,2.08.95,2.37.78l.51-.29a1.78,1.78,0,0,1,1.14-.07,6.24,6.24,0,0,1,2.06.75c1.21.7,1.73,1.54,1.17,1.86l-.5.29c-.29.17,0,.57.58.93l1.1.62C184.12,295.18,187.2,294.54,189.77,293.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "150.685px 273.685px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.69,291.19l13.81-8,.57-.35.44-.32s0,0,0,0c-1.58.69-3.72,0-5.13-.79a5.34,5.34,0,0,1-2-1.86,2.86,2.86,0,0,1-.35-2l-.19-.11-.39-.22-55-31.73-3.15-1.83-.91-.51-2.66-1.54a1.25,1.25,0,0,0-1.19,0l.59-.35,1.59-.91a1.17,1.17,0,0,1,1.11,0s0,0,0,0c.32.17.64.37,1,.56l.62.35c.36.22.72.42,1.06.61s.46.26.65.38l.47.27.81.46,43.66,25.22,13.95,8.05c1,.56,1.58,1.16,1.34,1.36l-.08.06-.49.28c-.61.35-.12,1.2,1.09,1.89a2.91,2.91,0,0,0,2.76.4l.6-.35a1,1,0,0,1,.87-.13l.32.19.69.4.85.49a.86.86,0,0,1,.46,1,.18.18,0,0,1,0,.14,1.25,1.25,0,0,1-.12.3h0a.69.69,0,0,1-.07.15,2.21,2.21,0,0,1-.34.48,4,4,0,0,1-.44.48c-.18.17-.36.32-.57.49a3.24,3.24,0,0,1-.35.27l-.29.2a7.15,7.15,0,0,1-.71.45l-13.81,8Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "169.515px 266.825px"
    },
    id: "elp7ct2s8pima",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc4jufst26i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.69,291.19l13.81-8,.57-.35.44-.32s0,0,0,0c-1.58.69-3.72,0-5.13-.79a5.34,5.34,0,0,1-2-1.86,2.86,2.86,0,0,1-.35-2l-.19-.11-.39-.22-55-31.73-3.15-1.83-.91-.51-2.66-1.54a1.25,1.25,0,0,0-1.19,0l.59-.35,1.59-.91a1.17,1.17,0,0,1,1.11,0s0,0,0,0c.32.17.64.37,1,.56l.62.35c.36.22.72.42,1.06.61s.46.26.65.38l.47.27.81.46,43.66,25.22,13.95,8.05c1,.56,1.58,1.16,1.34,1.36l-.08.06-.49.28c-.61.35-.12,1.2,1.09,1.89a2.91,2.91,0,0,0,2.76.4l.6-.35a1,1,0,0,1,.87-.13l.32.19.69.4.85.49a.86.86,0,0,1,.46,1,.18.18,0,0,1,0,.14,1.25,1.25,0,0,1-.12.3h0a.69.69,0,0,1-.07.15,2.21,2.21,0,0,1-.34.48,4,4,0,0,1-.44.48c-.18.17-.36.32-.57.49a3.24,3.24,0,0,1-.35.27l-.29.2a7.15,7.15,0,0,1-.71.45l-13.81,8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "169.515px 266.825px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-84",
    className: "animable",
    style: {
      transformOrigin: "341.55px 293.316px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-84",
    className: "animable",
    style: {
      transformOrigin: "341.55px 293.316px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-84",
    className: "animable",
    style: {
      transformOrigin: "386.24px 299.313px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315,377.9l12.36-71.27,7.81-.39L319,377.89h0a1.05,1.05,0,0,1-.53.7,3,3,0,0,1-2.78.14.93.93,0,0,1-.61-.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "325.085px 342.623px"
    },
    id: "elc8rxu0y5at8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.26,294.93h7.82l18.4,74h0a1,1,0,0,1-.57.86,3.11,3.11,0,0,1-2.79,0,1.07,1.07,0,0,1-.55-.68h0Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "444.37px 332.525px"
    },
    id: "elqrfff4uz4ua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.13,411.87l.34-79.82,7.82-.4-4.23,80.21h0a1,1,0,0,1-.52.7,3.1,3.1,0,0,1-2.78.14.94.94,0,0,1-.62-.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "381.21px 372.307px"
    },
    id: "elfi9ojjv3vl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.54,270.09h7.83l12.53,78.66h0a1,1,0,0,1-.57.86,3.11,3.11,0,0,1-2.79,0,1.05,1.05,0,0,1-.56-.68h0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.72px 310.015px"
    },
    id: "elsp9hz139cwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-84",
    className: "animable",
    style: {
      transformOrigin: "390.521px 262.475px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.79,208.48a43.86,43.86,0,0,1,3.12,13.74c.9,10.53-2.67,44.64-4.81,59.89h0c-3.1,25.49-6.9,25.53-12.42,29.8-9.5,7.34-36.82,21.72-45.84,25.27-16.35,6.44-29.71-3.48-39.68-8.41a230.57,230.57,0,0,1-26.4-15.63c-2.49-1.81-3.78-3.65-3.75-5.58,0-.76,0-3.89,0-4.7,0-2.46,2.17-5.1,6.74-8.06,8.45-5.48,39-23.28,50.8-29.83a.12.12,0,0,1,.1-.1c9.1-5.52,14.57-43.08,20.88-63.06.13-.42.26-.84.4-1.24s.22-.63.33-.93c.4-1.08.81-2.08,1.24-3",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "390.531px 267.964px"
    },
    id: "elshfueaal11m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,302.85c0-2.46,2.17-5.1,6.75-8.06,8.44-5.48,39-23.28,50.79-29.83a.12.12,0,0,1,.1-.1c9.1-5.52,14.57-43.08,20.88-63.06a34.89,34.89,0,0,1,1.32-3.67c0-.09.07-.18.11-.27q.17-.39.36-.81l.18-.41h0a19.2,19.2,0,0,1,4.2-6.07,9.42,9.42,0,0,1,2.07-1.45c1-.58,3.17-1.77,3.7-2.09,6.19-3.7,14.29.74,24.4,6.28,6.28,3.44,11.64,7.54,14.91,15.17h0a43.86,43.86,0,0,1,3.12,13.74c.9,10.53-2.67,44.64-4.81,59.89h0c-3.1,25.49-6.9,25.53-12.42,29.8-9.5,7.34-36.82,21.72-45.84,25.27-16.35,6.44-29.71-3.48-39.68-8.41a230.57,230.57,0,0,1-26.4-15.63c-2.49-1.81-3.78-3.65-3.75-5.58C324,306.79,324,303.66,324,302.85Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "390.511px 262.479px"
    },
    id: "el65ny8zwtbz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el90h782xd5j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324,302.85c0-2.46,2.17-5.1,6.75-8.06,8.44-5.48,39-23.28,50.79-29.83a.12.12,0,0,1,.1-.1c9.1-5.52,14.57-43.08,20.88-63.06a34.89,34.89,0,0,1,1.32-3.67c0-.09.07-.18.11-.27q.17-.39.36-.81l.18-.41h0a19.2,19.2,0,0,1,4.2-6.07,9.42,9.42,0,0,1,2.07-1.45c1-.58,3.17-1.77,3.7-2.09,6.19-3.7,14.29.74,24.4,6.28,6.28,3.44,11.64,7.54,14.91,15.17h0a43.86,43.86,0,0,1,3.12,13.74c.9,10.53-2.67,44.64-4.81,59.89h0c-3.1,25.49-6.9,25.53-12.42,29.8-9.5,7.34-36.82,21.72-45.84,25.27-16.35,6.44-29.71-3.48-39.68-8.41a230.57,230.57,0,0,1-26.4-15.63c-2.49-1.81-3.78-3.65-3.75-5.58C324,306.79,324,303.66,324,302.85Z",
    style: {
      opacity: 0.15,
      transformOrigin: "390.511px 262.479px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.17,324a233.35,233.35,0,0,1-26.4-15.64c-5.66-4.12-5.14-8.33,3-13.6C342,287.47,388,261.37,388,261.37S446.2,295.69,443.7,302s-38.5,26-49.84,30.41C377.5,338.87,364.13,329,354.17,324Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "383.894px 297.952px"
    },
    id: "elseka1bbkmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela10yvuok7kn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.17,324a233.35,233.35,0,0,1-26.4-15.64c-5.66-4.12-5.14-8.33,3-13.6C342,287.47,388,261.37,388,261.37S446.2,295.69,443.7,302s-38.5,26-49.84,30.41C377.5,338.87,364.13,329,354.17,324Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "383.894px 297.952px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,189.12c6.12-3.21,14.07,1.16,23.91,6.55,6.31,3.45,11.68,7.55,14.94,15.21l4.16-2.4c-3.27-7.63-8.63-11.73-14.91-15.17-10.11-5.54-18.21-10-24.39-6.28C414,187.35,411.8,188.54,410.78,189.12Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "432.285px 198.271px"
    },
    id: "el2xgwadk3k22",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el16vwrd45pp9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.78,189.12c6.12-3.21,14.07,1.16,23.91,6.55,6.31,3.45,11.68,7.55,14.94,15.21l4.16-2.4c-3.27-7.63-8.63-11.73-14.91-15.17-10.11-5.54-18.21-10-24.39-6.28C414,187.35,411.8,188.54,410.78,189.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "432.285px 198.271px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.65,264.86s5.93,1.95,27.08,12.34c8.69,4.26,14.4,8.56,22.53,13.68,12,7.53,11.06,13.12,11.06,13.12,5.95-4.93,11.88-62.11,10.42-79.42a43.71,43.71,0,0,0-3.41-14.4c-.16-.34-.32-.68-.49-1s-.23-.46-.35-.68l-.18-.32a25.19,25.19,0,0,0-1.51-2.41l-.39-.56c-.15-.18-.28-.37-.42-.55l-.42-.53-.37-.42a25.26,25.26,0,0,0-2.15-2.23,7.15,7.15,0,0,0-.57-.53,35.12,35.12,0,0,0-3.78-2.87c-.21-.14-.41-.28-.61-.4l-.84-.52c-.23-.14-.46-.29-.7-.42-.61-.36-1.23-.72-1.86-1.06-7.52-4.12-13.94-7.65-19.28-7.65a10,10,0,0,0-6.7,2.55c-3.95,3.48-6,10.81-6.18,11.23C396.22,221.78,390.75,259.34,381.65,264.86Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "417.307px 246.015px"
    },
    id: "elgzca3cpmwzo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elabrwogq3arm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.65,264.86s5.93,1.95,27.08,12.34c8.69,4.26,14.4,8.56,22.53,13.68,12,7.53,11.06,13.12,11.06,13.12,5.95-4.93,11.88-62.11,10.42-79.42a43.71,43.71,0,0,0-3.41-14.4c-.16-.34-.32-.68-.49-1s-.23-.46-.35-.68l-.18-.32a25.19,25.19,0,0,0-1.51-2.41l-.39-.56c-.15-.18-.28-.37-.42-.55l-.42-.53-.37-.42a25.26,25.26,0,0,0-2.15-2.23,7.15,7.15,0,0,0-.57-.53,35.12,35.12,0,0,0-3.78-2.87c-.21-.14-.41-.28-.61-.4l-.84-.52c-.23-.14-.46-.29-.7-.42-.61-.36-1.23-.72-1.86-1.06-7.52-4.12-13.94-7.65-19.28-7.65a10,10,0,0,0-6.7,2.55c-3.95,3.48-6,10.81-6.18,11.23C396.22,221.78,390.75,259.34,381.65,264.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "417.307px 246.015px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-84",
    className: "animable",
    style: {
      transformOrigin: "373.73px 339.706px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,327.28l-11.1-14.48-17.26,12.71c11.51,7.8,24.17,17.54,27.28,21.3,0,0,9.81-4.17,10.44-9.68S373,328.5,370,327.28Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "360.52px 329.805px"
    },
    id: "el3hejqlw2i5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.63,331.41a8.71,8.71,0,0,1,2.72,2c.84.86,1.52,5.63,2.56,7.71s1.63,2.57,3.19,5.13c1.74,2.83,4.41,5.22,3.44,13.51s-4.17,12.76-7.1,15.29a8.76,8.76,0,0,1-3.78,1.7s-4.61-.83-4.43-3.5S382.63,331.41,382.63,331.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.986px 354.08px"
    },
    id: "elmgc8xnj0tyl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.34,343.54c.27.78,1.63,1.82,2.21,2.39,2,1.93,3.23,4.8,4.25,7.32,4.85,11.94,1.1,19.16,8.64,22.57,2.17.86,6.12-.22,10.76-9.18,2.37-4.58,2.62-13.12.71-16.62s-4-5.6-5.34-8.32-1.9-8.13-3.94-10.29a11.76,11.76,0,0,0-4.5-2.61c-1.32-.5-4.08-1-5.42-1.43s-2.15-1.11-2.76-.09l1.71,1.46c2.74,2.61,2.22,3.16,2.47,4.78a24.88,24.88,0,0,0,1.76,5c-1.91-1.67-2.87-3.26-4.5-2.64s-1.85.57-3.85,3.29S365.1,342.84,365.34,343.54Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "379.23px 351.404px"
    },
    id: "eln78diecfjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyg6kde6tu1m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.34,343.54c.27.78,1.63,1.82,2.21,2.39,2,1.93,3.23,4.8,4.25,7.32,4.85,11.94,1.1,19.16,8.64,22.57,2.17.86,6.12-.22,10.76-9.18,2.37-4.58,2.62-13.12.71-16.62s-4-5.6-5.34-8.32-1.9-8.13-3.94-10.29a11.76,11.76,0,0,0-4.5-2.61c-1.32-.5-4.08-1-5.42-1.43s-2.15-1.11-2.76-.09l1.71,1.46c2.74,2.61,2.22,3.16,2.47,4.78a24.88,24.88,0,0,0,1.76,5c-1.91-1.67-2.87-3.26-4.5-2.64s-1.85.57-3.85,3.29S365.1,342.84,365.34,343.54Z",
    style: {
      opacity: 0.4,
      transformOrigin: "379.23px 351.404px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgnfimvg5ptm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.2,366.64c2.37-4.58,2.62-13.12.71-16.62a35.3,35.3,0,0,0-2.1-3.34c.1.25.22.49.29.7.17.46.32.93.46,1.41a11.25,11.25,0,0,1,.43,5.75c-.41,1.68-1.31,5.86-3.38,6.33-1.18.27-2.39-.7-3.09-1.94-.3-.52-.9-2-.9-2a18.76,18.76,0,0,0-5,3.23c-2.66,2.57-2.46,3-2.46,3a8.11,8.11,0,0,1,.59,2.64,6.68,6.68,0,0,1-.63,2.86,4.1,4.1,0,0,1-.66.76c.66,2.84,1.83,4.95,5,6.38C382.61,376.68,386.56,375.6,391.2,366.64Z",
    style: {
      opacity: 0.3,
      transformOrigin: "384.32px 361.365px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M371.8,353.25a42.78,42.78,0,0,1,2.63,9.77c1.73,3,2.71,2.69,2.54,1s-3.64-8.1-6.32-13.44C371.07,351.49,371.45,352.39,371.8,353.25Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "373.82px 357.934px"
    },
    id: "eld3sd00i8za8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,331.94a7.07,7.07,0,0,0-2.06-4.31c-.33-.09-.63-.17-.88-.26-1.45-.5-2.15-1.11-2.76-.09l1.71,1.46c2.74,2.61,2.22,3.16,2.47,4.78a24.88,24.88,0,0,0,1.76,5c2.27,5.15,3.76,6.73,5.3,11.71s1.16,8.59,1.94,8.75,2.11-.7,1.62-4.83-3.58-10.64-5.45-13.66S375.79,334.17,375.65,331.94Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "377.403px 342.862px"
    },
    id: "elv9a5vtoju7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.05,357.25a.43.43,0,0,1-.23.19,12.39,12.39,0,0,0-7.25,6.29.52.52,0,0,1-.7.19.51.51,0,0,1-.19-.71,13.34,13.34,0,0,1,7.75-6.72.52.52,0,0,1,.67.28A.51.51,0,0,1,384.05,357.25Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "379.872px 360.219px"
    },
    id: "elie8984xdgz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.62,353.13a.54.54,0,0,1-.23.19,13.83,13.83,0,0,0-7.6,6.8.51.51,0,0,1-.73.19.52.52,0,0,1-.19-.72,14.88,14.88,0,0,1,8.1-7.24.52.52,0,0,1,.69.27A.54.54,0,0,1,382.62,353.13Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "378.251px 356.349px"
    },
    id: "elxz6nwdwybio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,348.44a.64.64,0,0,1-.25.21,15.72,15.72,0,0,0-8.49,7.63.59.59,0,0,1-1-.59,16.9,16.9,0,0,1,9-8.11.58.58,0,0,1,.77.3A.61.61,0,0,1,381.84,348.44Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.994px 352.007px"
    },
    id: "elc1o5c7t2ttp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.41,344.57a.55.55,0,0,1-.24.21,15.33,15.33,0,0,0-8.31,7.45.57.57,0,0,1-1-.57,16.44,16.44,0,0,1,8.84-7.93.56.56,0,0,1,.75.29A.54.54,0,0,1,380.41,344.57Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "375.646px 348.1px"
    },
    id: "elvk1h1bi65h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.23,341a.62.62,0,0,1-.25.2,15.33,15.33,0,0,0-8.3,7.46.58.58,0,0,1-.79.21.59.59,0,0,1-.21-.79,16.51,16.51,0,0,1,8.84-7.93.58.58,0,0,1,.76.3A.6.6,0,0,1,378.23,341Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "373.465px 344.525px"
    },
    id: "el3mpslu182ul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.19,261.91s-44.57,9.85-60.74,14.24c-16.51,4.47-14.76,17.29-8.62,23.79C321.6,312.41,355,335.39,355,335.39s9.47-5.83,10.2-14.58l-9.18-13,33.21-4.05L394,298Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "349.722px 298.65px"
    },
    id: "elewvohknloqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,322c2.35-5.47,4.44-7.15,10.25-11.06l7,9.87c-.73,8.75-10.2,14.58-10.2,14.58s-3.86-2.65-9.4-6.64A63.52,63.52,0,0,1,348,322Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "355.45px 323.165px"
    },
    id: "el0mb7i8mm3hvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.25,294.8c2.89,2.54,5.43,4.84,7.65,7.09s7.35,2.27,11.92,0c5.69-2.82,11.72-7.62,15.24-10.38-5.18-5.78-3.12-14.25-3.12-14.25.52,5.5,3,10.07,5.65,12.25l2.81,2,1,8.71-1.57,3.43-33.78,4.2c-9.27-12.05-12.47-17.59-20.23-18.51C335.83,289.31,341.7,287.28,350.25,294.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "363.61px 292.555px"
    },
    id: "el2u5gtapc71u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.94,390.57l.47-1.59,10.81-28-20.39-7.63c-2.66,14.41-5.93,33.42-9,38.42,0,0,5.53,8.57,11,7.57S355.67,393.86,355.94,390.57Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "352.525px 376.386px"
    },
    id: "elkaybr7am8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.23,400.8a8.49,8.49,0,0,1-1.16,3.21c-.57,1.05-4.94,3.09-6.62,4.69s-2,2.32-4,4.56c-2.2,2.48-3.71,5.73-11.92,7.23s-13.42-.26-16.69-2.32a8.83,8.83,0,0,1-2.73-3.12s-.56-4.65,2.05-5.26S355.23,400.8,355.23,400.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.645px 410.925px"
    },
    id: "elmg87mqslcy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.58,387.81c-.67.49-1.26,2.09-1.64,2.81-1.27,2.44-3.64,4.49-5.75,6.21-10,8.13-18,6.64-19.07,14.86-.19,2.32,2,5.78,11.93,7.6,5.06.93,13.31-1.33,16.1-4.17s4.18-5.49,6.4-7.54,7.21-4.2,8.68-6.78a11.61,11.61,0,0,0,1.19-5.06c.09-1.41.13-6.17.13-6.17-1.69,3.39-4.34,3-5.81,3.72a25.4,25.4,0,0,0-4.23,3.13c1-2.31,2.27-3.69,1.21-5.07s-1.09-1.61-4.28-2.72S339.18,387.38,338.58,387.81Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "334.329px 403.544px"
    },
    id: "el6qjgycdobl6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr9eafa5jnn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.58,387.81c-.67.49-1.26,2.09-1.64,2.81-1.27,2.44-3.64,4.49-5.75,6.21-10,8.13-18,6.64-19.07,14.86-.19,2.32,2,5.78,11.93,7.6,5.06.93,13.31-1.33,16.1-4.17s4.18-5.49,6.4-7.54,7.21-4.2,8.68-6.78a11.61,11.61,0,0,0,1.19-5.06c.09-1.41.13-6.17.13-6.17-1.69,3.39-4.34,3-5.81,3.72a25.4,25.4,0,0,0-4.23,3.13c1-2.31,2.27-3.69,1.21-5.07s-1.09-1.61-4.28-2.72S339.18,387.38,338.58,387.81Z",
    style: {
      opacity: 0.4,
      transformOrigin: "334.329px 403.544px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elln31wjl6utq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.05,419.29c5.06.93,13.31-1.33,16.1-4.17a34.16,34.16,0,0,0,2.57-3c-.2.17-.39.36-.57.49-.4.29-.81.58-1.22.85a11.47,11.47,0,0,1-5.37,2.09c-1.73.09-6,.46-7.05-1.39-.6-1,0-2.49.95-3.52.42-.43,1.62-1.43,1.62-1.43a18.39,18.39,0,0,0-4.55-3.85c-3.23-1.79-3.58-1.48-3.58-1.48a8.35,8.35,0,0,1-2.35,1.34,6.7,6.7,0,0,1-2.92.22,4.26,4.26,0,0,1-.92-.4c-2.52,1.46-4.2,3.19-4.64,6.64C311.93,414,314.12,417.47,324.05,419.29Z",
    style: {
      opacity: 0.3,
      transformOrigin: "327.414px 411.681px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.19,396.83a42.56,42.56,0,0,1-8.59,5.36c-2.33,2.53-1.77,3.38-.22,2.73s6.68-5.84,11-10C332.66,395.62,331.91,396.24,331.19,396.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "327.206px 400.025px"
    },
    id: "elwkvodqhpoj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.68,394.28c1.49-.56,2.7-.81,3.79-1.9.71-.65.23-2.56-.06-3.4l-.54,1.7c-2,1.68-3.66,1.9-5.13,2.61a25.4,25.4,0,0,0-4.23,3.13c-4.27,3.68-5.35,5.56-9.66,8.5s-7.87,3.62-7.79,4.4,1.28,1.82,5.08.14,9.14-6.53,11.47-9.2S350.6,395.07,352.68,394.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "342.949px 399.671px"
    },
    id: "elm2b0mxa833l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93,409.71a.49.49,0,0,1-.25-.16,12.36,12.36,0,0,0-8.12-5.1.52.52,0,1,1,.23-1,13.42,13.42,0,0,1,8.7,5.45.53.53,0,0,1-.08.73A.52.52,0,0,1,330.93,409.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.836px 406.574px"
    },
    id: "elyom4g2a5z5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,407.14a.67.67,0,0,1-.25-.16,13.87,13.87,0,0,0-8.72-5.29.51.51,0,0,1-.4-.63.53.53,0,0,1,.64-.4,14.9,14.9,0,0,1,9.29,5.63.52.52,0,0,1-.06.74A.54.54,0,0,1,334.46,407.14Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "330.11px 403.903px"
    },
    id: "el2kqnnl4v84g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,405a.61.61,0,0,1-.28-.18,15.75,15.75,0,0,0-9.77-5.89.58.58,0,1,1,.26-1.14,16.93,16.93,0,0,1,10.4,6.27.58.58,0,0,1-.06.82A.57.57,0,0,1,338.72,405Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "333.842px 401.4px"
    },
    id: "ele7ybu6pdw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,402.53a.59.59,0,0,1-.27-.18,15.37,15.37,0,0,0-9.55-5.76.58.58,0,0,1-.43-.69.57.57,0,0,1,.69-.42,16.43,16.43,0,0,1,10.16,6.13.57.57,0,0,1-.06.81A.56.56,0,0,1,342,402.53Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "337.239px 399.01px"
    },
    id: "elh9gelyrryi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.82,399.38a.54.54,0,0,1-.27-.18,15.37,15.37,0,0,0-9.56-5.76.57.57,0,0,1,.26-1.11,16.45,16.45,0,0,1,10.17,6.13.57.57,0,0,1-.6.92Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "340.057px 395.861px"
    },
    id: "elq0ff4u8pb9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,378.93c5.35,5.56,18.24,5.16,18.24,5.16s3.71-7.08,10.4-22.57c3.73-8.65,5.81-12.57,7.39-24.65,11.35-5.56,31.52-13.54,50.64-27.83,13.69-10.24,15.86-24.14,14.12-40.61-2.14-20.24-61.57-3.71-61.57-3.71,3.93,11,3.05,21.79,10.47,26.76,0,0-23.93,17.17-32,23.3-3.71,2.81-5.46,3.74-7.24,12.27C345.92,352,340.71,378.93,340.71,378.93Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.363px 321.228px"
    },
    id: "elm9d0n88n4eg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12,384l-1.06-.07c4.11-7.73,10.32-24.32,12.63-31.47.76-2.33,2.31-8.89,2.77-10.69,2.19-8.58,2.5-11.7,4.86-12.51.59-.2,1.89-1,3.93-2,10.36-5.14,35.42-17.87,44.08-26,.25-.24.48-.5.73-.75-4.37-2.51-5.72-9.18-4.14-13.91,1.69-5.06,1.58-14.22-1.09-18l.78-.55c3.11,4.4,2.8,14.1,1.22,18.84-1.49,4.44-.1,10.78,3.93,12.91,8.07-8.61,10.15-20.48,6-34.48l.91-.27C436.17,280.29,433.52,293,424,302c-8.76,8.23-33.92,21-44.31,26.16-1.95,1-3.36,1.67-3.9,2-2.24,1.22-3.07,7.12-4.36,12.07-.47,1.81-2,8.3-2.83,10.64C366.07,360.1,360,376.5,356.12,384Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "394.431px 324.525px"
    },
    id: "el2mk4gkjf6gh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-84",
    className: "animable",
    style: {
      transformOrigin: "329.72px 345.822px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "346.78 348.34 350.03 346.46 358.47 452.68 355.22 454.56 346.78 348.34",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "352.625px 400.51px"
    },
    id: "el9n65fc89h0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.78 348.34 341.92 345.53 351.97 452.68 355.22 454.56 346.78 348.34",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "348.57px 400.045px"
    },
    id: "el4tf1zbs6z9o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.09 297.22 261.34 295.34 251.29 390.89 248.04 392.76 258.09 297.22",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "254.69px 344.05px"
    },
    id: "elk1rk7fw5eap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.09 297.22 253.23 294.41 244.79 390.89 248.04 392.76 258.09 297.22",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "251.44px 343.585px"
    },
    id: "el1cq7r8msxga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.5 315.63 406.75 313.75 415.19 419.97 411.94 421.85 403.5 315.63",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "409.345px 367.8px"
    },
    id: "eljxrfzcuwnlb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.5 315.63 398.64 312.82 408.69 419.97 411.94 421.85 403.5 315.63",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "405.29px 367.335px"
    },
    id: "eliu3jea83gwb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.81 264.51 318.06 262.63 308.01 358.18 304.76 360.05 314.81 264.51",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "311.41px 311.34px"
    },
    id: "elqtf6iyvrld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.81 264.51 309.95 261.7 301.51 358.18 304.76 360.05 314.81 264.51",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "308.16px 310.875px"
    },
    id: "elzrjdzheugme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-84",
    className: "animable",
    style: {
      transformOrigin: "329.72px 299.97px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.8,314V310.1a2.18,2.18,0,0,0-1-1.71l-123-71.06a2.16,2.16,0,0,0-2,0l-81.18,46.95a2.16,2.16,0,0,0-1,1.71v3.85a2.19,2.19,0,0,0,1,1.71l123,71.06a2.16,2.16,0,0,0,2,0l81.18-46.95A2.16,2.16,0,0,0,433.8,314Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.71px 299.97px"
    },
    id: "ellf7dglu0eb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el08i6b9e8nd89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.8,314V310.1a2.18,2.18,0,0,0-1-1.71l-123-71.06a2.16,2.16,0,0,0-2,0l-81.18,46.95a2.16,2.16,0,0,0-1,1.71v3.85a2.19,2.19,0,0,0,1,1.71l123,71.06a2.16,2.16,0,0,0,2,0l81.18-46.95A2.16,2.16,0,0,0,433.8,314Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "329.71px 299.97px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M350.64,356.72v6.13a2.1,2.1,0,0,0,1-.23l81.18-46.95a2.2,2.2,0,0,0,1-1.72V310.1a2.18,2.18,0,0,0-.81-1.58c.36.31.3.73-.18,1l-81.18,47A2,2,0,0,1,350.64,356.72Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "392.23px 335.685px"
    },
    id: "elcy5gqpkvtch",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.81,309.53l-81.18,47a2.16,2.16,0,0,1-2,0l-123-71.06c-.55-.32-.55-.83,0-1.14l81.18-46.95a2.16,2.16,0,0,1,2,0l123,71.06C433.36,308.71,433.36,309.22,432.81,309.53Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "329.72px 296.955px"
    },
    id: "elq2u3av4wqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4c93e8n4unr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.81,309.53l-81.18,47a2.16,2.16,0,0,1-2,0l-123-71.06c-.55-.32-.55-.83,0-1.14l81.18-46.95a2.16,2.16,0,0,1,2,0l123,71.06C433.36,308.71,433.36,309.22,432.81,309.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "329.72px 296.955px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-84",
    className: "animable",
    style: {
      transformOrigin: "324.044px 283.787px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-84",
    className: "animable",
    style: {
      transformOrigin: "324.044px 283.787px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "elxekpwa6092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.53,275l43.23-25a2.51,2.51,0,0,1,2.49,0l75,43.31a.56.56,0,0,1,0,1l-43.64,25.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "324.044px 284.59px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.66,271.3v.94a3.82,3.82,0,0,0,1.91,3.31l67,38.68a3.75,3.75,0,0,0,1.91.51,3.9,3.9,0,0,0,1.93-.51l36.52-21a3.84,3.84,0,0,0,1.91-3.31v-1.29h0a.48.48,0,0,1-.24.42L340.47,312.2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "325.25px 293.02px"
    },
    id: "ela7atn25hh1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.65,271.3l39.72-22.93a2.29,2.29,0,0,1,2.29,0l68.91,39.79a.51.51,0,0,1,0,.88L340.48,312.2Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "325.236px 280.132px"
    },
    id: "els8eusz9xtwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.84 308.82 362.27 296.46 299.62 260.29 278.08 272.59 340.84 308.82",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "320.175px 284.555px"
    },
    id: "elndx0omfjk0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.08 272.59 278.9 273.06 299.62 261.24 361.45 296.94 362.26 296.47 299.62 260.29 278.08 272.59",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.17px 278.615px"
    },
    id: "el85zie74j1n5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.37 274.45 350.98 274.67 340.48 280.74 321.8 269.95 321.41 269.73 332.31 263.44 351.37 274.45",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.39px 272.09px"
    },
    id: "elb0e8l4d2i2r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.98 274.67 340.48 280.74 321.8 269.95 332.31 263.89 350.98 274.67",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "336.39px 272.315px"
    },
    id: "elyohugp3s6oa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,312.19v2.55a3.86,3.86,0,0,1-1.92-.51l-67-38.68a3.82,3.82,0,0,1-1.92-3.32v-.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.06px 293.02px"
    },
    id: "el24x4s3apbzz",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-84",
    className: "animable",
    style: {
      transformOrigin: "357.435px 230.965px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.48,240.14c6.6-2.56,23.18-9.85,23.18-9.85s14.95-25.08,18.22-30.34c3.92-6.29,9.47-11,18.56-10.28l-1.6,26.27s-16.12,23.13-19,26.94c-2.19,2.89-2.06,3.71-7.86,4.92l-27.43,5.73-1.1.33a3.8,3.8,0,0,0-1.92,1.3,10.84,10.84,0,0,0-1.2,2c-1.15,2.45-1.06,3.28-2.24,5.93s-1.74,2.41-3.59,4.43-2.46,3.16-3.3,3-1.27-2.33-.66-4.15,2.39-3.44,2.68-4.19.22-1.84-1.85-1.4-6.55,4.43-8.55,6.14-3.63,4.3-5.45,5.41-1.72-.77-1.85-2.39-1.77-4.08-1.77-6.65,2.87-8.74,5.47-10.82,7.61-5.67,8.94-6.45A76.21,76.21,0,0,1,340.48,240.14Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "357.095px 231.131px"
    },
    id: "elpnile4tgdz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.12,189.4c-3.91-.36-8.79-.18-12.87,3s-6.11,5.93-12.14,16.13-9,15.42-9,15.42a19.24,19.24,0,0,0,7.22,8.69,37.09,37.09,0,0,0,10.41,4.08L400,216Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "384.115px 212.993px"
    },
    id: "el3132sdpz3e7",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-84",
    className: "animable",
    style: {
      transformOrigin: "413.509px 210.727px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-84",
    className: "animable",
    style: {
      transformOrigin: "413.509px 210.727px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.38,213.76C386,196,392.06,190,401.12,189.4c.17,0,12.65.58,19.79,1.93,8.68,1.65,18.75,6.56,21.73,8.43,4.5,2.8,5.93,8.81,6,21.39a281.47,281.47,0,0,1-2.36,36.27,188.17,188.17,0,0,1-6.2,31.26c-12.51,4.18-62.08-11-61.7-26.87,1.29-3.63,3.52-7.83,4.54-15.19C384.23,233.68,383.87,219.34,384.38,213.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.509px 239.391px"
    },
    id: "el93le14jwbwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-84",
    className: "animable",
    style: {
      transformOrigin: "414.621px 166.384px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.6,184.84c1.22-4.89,6.54-9.69,9.09-13.84s4-7.14,4-11.08c0-2.33-1.19-5.59-2.86-6.38,2.65-8.47-3.48-12.41-6.32-13.65-1.24-.55-4-1.46-5.23-2.08-1.81-.92-2.12-2.46-3.53-3.85-2.42-2.4-6.79-2.78-8.7.43-1.56-2.37-3.91-2.49-6.66-2a4.63,4.63,0,0,0-3.94,5c-3.46-2.3-7,0-7.47,2.1-.36,1.55-.13,2.9-1.26,4.23-1.28,1.49-3.46,1.3-4,0-.54,2.2.2,4,2.63,4a5,5,0,0,0-1,4.2,4.62,4.62,0,0,0,3.94,3.5,7.08,7.08,0,0,0,3.47,6.26c3.52,2,7.53,2.9,11.41,4l4.6,1.32c.27.08,1.67.27,1.82.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "414.621px 158.456px"
    },
    id: "el6y902qi7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.09,178.89c-3.64,1.81-5.83-.62-5.83-.62l-1,16.37c-3.25,6.78-15.29,7.06-19.49,4.75s-3.45-4.85-.33-8.55l-.1-2.7a48.3,48.3,0,0,1-5.87-.71c-3.85-.83-6.54-4.2-7.33-8.49a44.11,44.11,0,0,1,.79-16.72,14.32,14.32,0,0,0,.52-4.06c-.1-3.65.71-5.7,1.88-8.67,4.53-3.12,14.51-3.54,23.31,2.77-1.48,5.4.32,9.91,4.16,12.31-.3,1.47-.77,5.2,1.67,5.31,1.76.08,2-2.11,4-3.91s6.19-2,7.61,1C439.05,171.12,437.08,176.89,433.09,178.89Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "415.269px 173.989px"
    },
    id: "el12te8cdens8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.84,161.3l11.44,4.08a4.75,4.75,0,0,0-1.84,1.76l-10-3.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "424.36px 164.22px"
    },
    id: "elefo4vo9a73i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.51,157.4c-.15,1.14.45,1.53.53,2.39a31.63,31.63,0,0,0,.06,4.65,4.78,4.78,0,0,0,4.1,4.06,5.1,5.1,0,0,0,5.78-2.39c1.08-1.55,1.19-4,2.68-3.72s.91,2.65,1.45,4.52a5.82,5.82,0,0,0,5,4.48,5.19,5.19,0,0,0,4.22-.78c1.82-1.33,2.18-4,2.88-5.78.33-.89,1.08-.94,1.35-2.06s-.6-1.62-1.49-1.8a24.86,24.86,0,0,0-8-1.28c-2.66.26-3.69.93-5.1.66s-2-1.26-4.25-2.46c-2-1-5.51-1.57-8.14-1.73C392.19,156.14,391.62,156.69,391.51,157.4Zm16.37,4.49a2.27,2.27,0,0,1,.83-.47l.15,0a9.64,9.64,0,0,1,3.82-.36c2.47.22,3.9,1.07,4.37,1.67.57.95-.37,3.68-.94,5h0a4.33,4.33,0,0,1-.25.47h0l-.15.26c-1.5,2.81-6.27,2.13-7.71-.31h0C406.93,166.28,406.93,163.21,407.88,161.89Zm-14.13-3.69a2,2,0,0,1,.67-.28h.05a3,3,0,0,1,.6-.1h.13c2.19-.23,6.06,1.38,6.8,3,.4,1-.26,3.13-.94,4.43a4.9,4.9,0,0,1-.69.95c-1,1.39-4.16,1.7-5.8.32-1.57-1.22-1.59-3.31-1.6-4.27C393,161,393.12,158.61,393.75,158.2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "405.548px 163.851px"
    },
    id: "el9t152cdg1j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.79,164.45,403,173.58l-5.62-3.5q.42-.5.84-1l.4-.51.84-1c.74-.91,1.49-1.8,2.19-2.58a22.09,22.09,0,0,1,1.61-1.6,0,0,0,0,0,0,0,9.62,9.62,0,0,1,.88-.74,2.55,2.55,0,0,1,.28-.21h.05l.15,0C405.53,162.56,405.7,163.4,405.79,164.45Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "401.585px 168.01px"
    },
    id: "elouqgkp3ntp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.35,188.14c6.22-.26,11-.57,14.51-4.8a38.9,38.9,0,0,0,4.26-7,30.06,30.06,0,0,1-3.33,9c-1.77,2.74-5.63,5-15.36,5.08Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "415.735px 183.38px"
    },
    id: "elsaxpusybjoc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.05,164.78a1.74,1.74,0,1,0,1.95-1.59A1.77,1.77,0,0,0,409.05,164.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.785px 164.918px"
    },
    id: "elnw0d2algvuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,157.5l3.89,1.71a2.23,2.23,0,0,0-1.13-2.87A2.07,2.07,0,0,0,411.82,157.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.848px 157.689px"
    },
    id: "el1y9jzsnr4wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.19,175.57l-5.9,1.27a3.16,3.16,0,0,0,3.7,2.36A2.94,2.94,0,0,0,410.19,175.57Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "407.29px 177.416px"
    },
    id: "elbf3vx3zx7sc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.32,179.08a3.57,3.57,0,0,1,3.95-2.65A2.91,2.91,0,0,1,408,179.2,3,3,0,0,1,406.32,179.08Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "408.295px 177.832px"
    },
    id: "el3lcoqd15rxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,156.19l4.28-.16a2.06,2.06,0,0,0-2.14-2.08A2.26,2.26,0,0,0,396.15,156.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "398.29px 155.069px"
    },
    id: "elhvq36zk5aiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,162.38a1.74,1.74,0,1,0,1.8-1.75A1.77,1.77,0,0,0,395.8,162.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.54px 162.369px"
    },
    id: "elz1670khlk8m",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-84",
    className: "animable",
    style: {
      transformOrigin: "399.826px 240.805px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.1,265A28.9,28.9,0,0,0,360,263.7c-4.24.25-7.57-.9-8.18-.69-2.24.8-.82,4.58,4.6,5.19C360.54,268.67,371.1,265,371.1,265Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "360.951px 265.613px"
    },
    id: "el83h3088dfri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51,278.2c-9.62,1.43-38.21,2.63-39.56,2.91-.58.12-3.15.54-3.81.65-1.42.24-2.8.53-4.23.74a12,12,0,0,1-2.47.18,32.05,32.05,0,0,1-5.73-1.11,10.46,10.46,0,0,0-4.62-.26c-1.9.33-3.76.78-5.65,1.2a7.47,7.47,0,0,1-4.58-.24,11.68,11.68,0,0,1-1.46-.83,8.46,8.46,0,0,0-2.31-.46,3.08,3.08,0,0,1-1.6-.87c-.23-.27-.29-.72-.57-.95a3,3,0,0,0-1.52-.38,11.81,11.81,0,0,1-2.36-.43c-1-.35-2.47-1.08-2.19-2.38.13-.59.61-.81,1.1-1.15.84-.58,1.74-1.15,2.53-1.8,1.85-1.51,3.93-2.71,5.78-4.21a11.23,11.23,0,0,1,5.65-2.2c2.17-.34,4.32-.86,6.5-1.11,1.79-.2,3.51-.87,5.32-.43,4.42,1.06,8.89,3.09,13.5,2.22C391.93,266,421.7,258,421.7,258l7.18-27s5-24.2,12.61-31.33c5.51,2.09,10.48,6.27,12.11,11.88,1.92,6.64-.09,12.43-3.87,28.51-2.87,12.2-3.47,13.31-6.76,24.76C440.26,274.14,439.3,276.46,427.51,278.2Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "399.577px 241.215px"
    },
    id: "el1dflm5julw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.07,198.85c5.76,2.66,12.07,6.23,13.59,15.51s-7.22,37.51-7.22,37.51-5.41.69-13.24-1.67-9.59-5.93-9.59-5.93,2.66-12.25,4.18-18S433.42,205.86,441.07,198.85Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "439.724px 225.407px"
    },
    id: "el7wimhrrug3f",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,312.76a4.56,4.56,0,0,1-3.91-.3L268.79,274a4.54,4.54,0,0,1-2.21-3.18l-7.3-43.54a4.74,4.74,0,0,1-.06-.75,4.52,4.52,0,0,1,1.34-3.22l69.31,40a3.36,3.36,0,0,1,1.63,2.35Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "299.31px 268.188px"
    },
    id: "eljo4kfn5dsd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,312.2l-.46.26c-.2.11-.41.21-.62.3l-7.9-47.13a3.36,3.36,0,0,0-1.63-2.35l-69.31-40a4.6,4.6,0,0,1,.92-.71l69.46,40.1a3.37,3.37,0,0,1,1.63,2.35Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "300.52px 267.665px"
    },
    id: "eloivsrbeu3y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.86,264.17l1.07-.62a3.33,3.33,0,0,1,.64,1.45l7.91,47.2-.46.26c-.2.11-.41.21-.62.3l-7.9-47.13A3.37,3.37,0,0,0,330.86,264.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.67px 288.155px"
    },
    id: "el8wesp3v4shc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.83,272.56c-.49-2.92-3.5-6.79-6.72-8.65s-5.45-1-5,1.91,3.5,6.79,6.73,8.65S302.32,275.47,301.83,272.56Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "295.975px 269.19px"
    },
    id: "elxh9c1jp5su",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-84",
    className: "animable",
    style: {
      transformOrigin: "123.845px 251.555px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-84",
    className: "animable",
    style: {
      transformOrigin: "123.845px 251.555px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.52,261.8c0,7.82,3.07,41.59,39.06,37.93,39.2-4,45.79-35.14,44-49.75-8-36.14-11.62-55.78-11.62-55.78H73S60.14,231.2,58.52,261.8Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "100.181px 247.103px"
    },
    id: "elzvhquj2lz5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-84",
    className: "animable",
    style: {
      transformOrigin: "105.805px 311.966px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-84",
    className: "animable",
    style: {
      transformOrigin: "105.805px 311.966px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "116.84 392.89 120.66 391.1 116.9 390.05 116.84 392.89",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.75px 391.47px"
    },
    id: "elhr1azfofdvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,400s-44.86-20.06-45.44-17.11a4.21,4.21,0,0,0,0,1.77,1,1,0,0,1-.12-.16l.79,5.51a13.53,13.53,0,0,0,7,2.91c0-.27,0-1.91.06-2.85a23.59,23.59,0,0,1,4,2.08c2.87,1.88,4.7,5.14,7.74,8.93,2.21,2.77,6.18,4.08,12.07,4.93,6.33.92,11.93-.23,13.51-1.87C155.45,402.8,154.84,400.37,154.61,400Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.008px 394.465px"
    },
    id: "el149dcs1ejks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.38,399c-.43-.44-2-2.17-4.19-4.06a83.1,83.1,0,0,0-6.45-5.43,24.25,24.25,0,0,1-3.21-2.61c-.78-.83-1.52-1.68-2.22-2.58a47.69,47.69,0,0,1-5.37-9,20.51,20.51,0,0,1-1.86-4.72,29.69,29.69,0,0,1-.5-5.23c0-7.91.19-9.16.26-15.18l-19,.49c.61,3.33,1.52,7.9,1.83,11.69.46,5.76.61,7-1.74,12.78-.7,1.69-1.72,3.31-1.82,5.12-.17,2.95,2.2,5.51,4.85,7,2.19,1.21,4.73,1.74,6.86,3a22,22,0,0,1,5.56,5.4c1.5,1.89,2.7,4.13,4.82,5.47a20.1,20.1,0,0,0,7.31,2.51,40,40,0,0,0,9.85.55C153,403.82,156.51,402.19,153.38,399Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "131.837px 377.241px"
    },
    id: "eluhbgb1q5qv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.82,395.72c-1.93-1.6-4.66-3.89-8-6.47a8.67,8.67,0,0,0-7,.57C129.16,393.2,128,398,128,398a9.48,9.48,0,0,0,5.42,4.68c7.7,3.33,21.54,2.38,21.7-1.08C155.21,399.44,153.16,397.66,150.82,395.72Zm-39.48-21.87s-.46,1.13-1.65,3.35a6.11,6.11,0,0,0,0,6.68,10.26,10.26,0,0,0,6.74,4.52C118.64,381.85,114,375.29,111.34,373.85Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "131.91px 389.296px"
    },
    id: "elpxpdi4r3zrn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.24,382.57c1.27,2-.38,9.45-.09,14.77.26,4.83,1.6,13.25.06,18-1.82,5.65-5.51,12.22-12.38,6.92-4.26-3.29-6.7-7.53-7.29-14.49-.4-4.83,1.59-11.52,3.31-17.45,2-6.92,2.76-10.63,2.76-10.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "66.7133px 401.951px"
    },
    id: "eleno94ek22ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.13,346.93c-.49,11.27.86,19.18.94,26.4A49,49,0,0,1,62,383.08c-1,4.6-2.64,11-3.34,14-1,4.17-1.71,6.8-.22,11.48a5.54,5.54,0,0,0,.49,1.05c2.08,3.86,7.36,6.77,9.06,6.3a3,3,0,0,0,3,1c.18,0,.37-.08.56-.13a3.88,3.88,0,0,0,.56-.23A5.58,5.58,0,0,0,74.92,413a9.46,9.46,0,0,0,.27-1c1.23-5.8.34-9.56.22-11.83-.13-2.62,0-6,.27-10.18s1.28-17.51,2.79-23.86c1.13-4.43,2.54-10,4-15.91Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "70.0275px 381.961px"
    },
    id: "elkxf0jlwvln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,402.5c4.17-1.78,16.27-2,18.19,3.67,0,5.36.09,9-3.41,13.66-4.65,6.2-10.72-.37-13.05-4.55S57.07,405.39,57.64,402.5Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "66.5738px 411.878px"
    },
    id: "elwxm4gpradgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9,199.72C72,209.94,67.26,218.55,65.72,245.55,64,276,64.25,287.61,64.1,291.29s-2.6,10.42-4.68,28.52.11,62,.11,62,1.47,3,8.63,3.63c6.6.62,10.47-1.63,10.47-1.63s10.49-57.63,13.08-68.52,10.14-46.73,10.14-46.73L106,297.7s-2.09,10-.2,25.88,5.6,48,5.6,48a38.18,38.18,0,0,0,10,2.5,24.9,24.9,0,0,0,11.09-1.24s5.55-64.73,5.69-82.74-1.3-62.95-7-89.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "98.3562px 292.634px"
    },
    id: "eln4og4dfmgqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,234l-6.16,34.59L106,297.7l-1.61-29.51,5.48-28.38c4.5-1,14.75-6.14,17.61-13.56C120.46,233.2,108,234,108,234ZM87.18,213.58c.82-2.9,1.68-5.79,2.64-8.7a42.49,42.49,0,0,0-4.1,8.24A77.83,77.83,0,0,0,83,221.87a88.7,88.7,0,0,0-1.78,9,59.08,59.08,0,0,0-.69,9.11c.78-3,1.5-5.89,2.22-8.83s1.42-5.87,2.17-8.79S86.39,216.49,87.18,213.58Zm-4.49-2.21c1-1.77,2.06-3.55,3-5.41a33.28,33.28,0,0,0-4.3,4.59,45.22,45.22,0,0,0-3.5,5.18,38.77,38.77,0,0,0-2.67,5.64,23.65,23.65,0,0,0-1.48,6l2.9-5.43c1-1.78,2-3.56,3-5.31S81.68,213.14,82.69,211.37ZM78.08,327Q75.36,341,73,355.14q3.48-13.9,6.58-27.87c2.1-9.31,4.08-18.61,6-28s3.11-18.87,4.13-28.35,1.82-19,2.49-28.5c-1.43,9.44-2.72,18.88-4,28.32s-2.68,18.85-4.55,28.17S79.87,317.61,78.08,327Zm51.26-47c.16,4.13.38,8.29.28,12.37s-.41,8.26-.66,12.39l-.74,12.42q-.75,12.42-1.2,24.87,1.61-12.36,2.75-24.76c.76-8.28,1.48-16.52,1.83-24.87,0-8.4-.63-16.65-1.34-24.94s-1.7-16.53-3-24.75l1.42,24.85C128.93,271.69,129.17,275.82,129.34,280Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "102.3px 280.01px"
    },
    id: "elqhc5pk4vykh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-84",
    className: "animable",
    style: {
      transformOrigin: "123.845px 170.349px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,115.32c.85-1.06,1.24-2.38,2-3.42a7.63,7.63,0,0,0,1.84-3.66c.11-.75.08-1.51.2-2.25a3,3,0,0,1,1-1.95c.82-.61,2-.51,2.87-1a3.42,3.42,0,0,0,1.6-3.08,10,10,0,0,0-.91-3.52,2.79,2.79,0,0,0,3.76-3.17,1.72,1.72,0,0,1-3,0,2.87,2.87,0,0,1-.27-1.45,23.67,23.67,0,0,0,.14-4.2,7.47,7.47,0,0,0-2.1-3.77c-3.76-4-9.65-5.4-15.1-4.83-2.17.23-4.22,1.11-6.45,1.22a22,22,0,0,1-4.85-.5,21.22,21.22,0,0,0-7.19-.33,8.41,8.41,0,0,0-5.92,3.73c-.71,1.24-1,2.77-2.17,3.64a6.62,6.62,0,0,1-2.79,1,15.69,15.69,0,0,0-7,3.22A8.54,8.54,0,0,0,72.49,98c.18,2.2,1.4,4.18,1.69,6.36.54,4-2.08,8.07-1,11.94s5.52,5.83,7.78,9.21c.9,1.35,1.44,2.92,2.28,4.31A11.67,11.67,0,0,0,87.67,134c1.83,1,3.89,1.3,5.83,2s4.4,1.65,6.33.38A18.2,18.2,0,0,0,101.4,135a9.88,9.88,0,0,1,3-1.79,19.54,19.54,0,0,0,2.81-1c2.2-1.18,3.19-3.76,3.87-6.16s1.33-5,3.23-6.63a40.06,40.06,0,0,1,3.57-2.19A8.88,8.88,0,0,0,120,115.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.452px 107.951px"
    },
    id: "elaxbwt5hb7k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.4,120.38a5.57,5.57,0,0,0-3.31.44,36.25,36.25,0,0,0-4.62,2.91c-2.37,1.45-6.17,3.83-9,3.86-.57,0-1.77-.17-1-.92a24.45,24.45,0,0,0,2.82-3,5,5,0,0,0,1-3.91,1.73,1.73,0,0,0-.63-1c-.49-.33-.81-.09-1.16.21a10.19,10.19,0,0,1-1.23.83l-2.56,1.66c-5,3.27-9.91,7-12.66,12.47-.4.78-2.73,6.93-4.26,10.4-1.23,3.17-9.75,23-9.75,23s-14.34-14.85-19-19.51c-5.08-5.06-10-7.56-18-7.21l6.72,26.55s19.56,17.63,22.51,19.54c4.36,2.82,12.69,8,17.64,2.58,6.06-6.66,7.75-17.49,9.68-25.4,2.18-8.91,2.76-13.16,4.13-15.89s3.86-3,5.57-3.68a27.44,27.44,0,0,0,6.74-3.37,25,25,0,0,0,5.09-4.2,7.67,7.67,0,0,0,1.92-2.56,24.41,24.41,0,0,1,.36-2.65c.37-1,1.19-1.75,1.45-2.77a9.55,9.55,0,0,0,0-2.45,4.15,4.15,0,0,1,1.61-3,3.76,3.76,0,0,0,1.07-1.41C196.79,121,196.15,120.54,195.4,120.38Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "154.314px 155.126px"
    },
    id: "elrphupjfpwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.68,153.55l2.83-7a16.38,16.38,0,0,0,5.74,8.55c4.45,3.17,7,3.09,7,3.09l-2.18,9a20.82,20.82,0,0,1-8.25-3.48C156.46,161,154.68,153.55,154.68,153.55Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "162.465px 156.87px"
    },
    id: "elr74bnya1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,167.28c-2.14,4.59-1.48,10.6-.79,12.74-3.49-7-1.79-11.84-.64-14.23Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "147.564px 172.905px"
    },
    id: "el44o7jdwyay6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.73,140.59c7.62,1.3,9.18,3.64,13.84,8.21S149,166.43,149,166.43l6.54-15.38s0,4.75,5,9.24,8.72,4.41,8.72,4.41-2.5,11.91-6.3,19.86-7.78,9-14.6,6.66-23.82-17.36-23.82-17.36Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "143.495px 166.453px"
    },
    id: "elo8lu01y243",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrqsjus6o53a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.73,140.59c7.62,1.3,9.18,3.64,13.84,8.21S149,166.43,149,166.43l6.54-15.38s0,4.75,5,9.24,8.72,4.41,8.72,4.41-2.5,11.91-6.3,19.86-7.78,9-14.6,6.66-23.82-17.36-23.82-17.36Z",
    style: {
      opacity: 0.15,
      transformOrigin: "143.495px 166.453px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.39,130.21a18.36,18.36,0,0,1-5.88,8.25,7.55,7.55,0,0,0,4.55-2.64A7.12,7.12,0,0,0,175.39,130.21Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "172.51px 134.335px"
    },
    id: "elwygf6ga2pyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-84",
    d: "M70.11,213.76c-5.65-2.66.54-6.39,1.77-23.69.31-4.46-1.18-15.52-1.18-15.52s9.82-11.34,7.22-32.86l19.27-2.56,12.55.09,8,2.37c2.7,2.43,7.67,6.27,11.6,12.09,5.68,8.39,6.54,17.52.41,24.19-.09,1.32.77,21.56,2.42,26.5,1.53,4.6,1.86,5.11-.61,7.16C123.77,217.21,80.12,217.61,70.11,213.76Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "100.877px 177.709px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.74,139.22l8,1.37c7.57,6,16.51,16.67,16.85,24.76a42.58,42.58,0,0,1-1.41,13.53s-.86,16.75.83,25.46c1.4,7.16,2.75,14.34,4.11,21.51.67,3.5,3.8,20.05,3.46,25a46.44,46.44,0,0,1-11.5-18.26c-3.54-9.89-4.37-20.53-5.21-30.92-.66-8.09-1.66-16.43-1.26-24.56C124.08,167.36,124.59,151.89,109.74,139.22Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "125.673px 195.035px"
    },
    id: "elyixplto34fd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.48,140.09c1.25-.17,5.27,9.68,5.71,10.52,3.27,6.24,4.28,13.92,5,20.92,1.7,15.4.27,31-3,46.13a78.75,78.75,0,0,1-3.93,13.52c-5.56,13.52-19.81,26.43-33.82,30.62,0-11,1.87-22.12,3.39-32,1.11-7.25,2.22-14.5,3.73-21.68,2.85-13.47,5-26.45,5.32-40.2q.3-12.75.56-25.49Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "79.1754px 200.944px"
    },
    id: "el4ymfjnc1o37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-84",
    className: "animable",
    style: {
      transformOrigin: "90.2041px 176.774px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111,169.17c3.61-2.69,5.43-3.73,7.12-4.21s7.59-2.94,9.86-3.5c1.43-.36,2,1.93.19,3.5-1.41,1.21-5.08,2.8-6.69,3.68s-4.76,4.71-4.76,4.71Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "120.153px 167.386px"
    },
    id: "el5k1peivryhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.17,151.6c3.58-7.64,6.63-8.37,15.3-9.38C83.63,150.17,77,168,77,168l-3.94,18.69s21.18-3.07,23.62-4.63,9-8.61,11.2-10.73c3-2.87,4.48-2.48,6-2.26,5,.75,6.07,1.17,7.13,1.84a2.27,2.27,0,0,1,1,1.94c1.32.17,3.3.13,3.55,2.3a6,6,0,0,1,.08,1.74,1.44,1.44,0,0,1,.86.49c1.1,1.28-.78,5.69-2,6.77-.85.76-2.05.85-3.62.64-1.34-.18-.72-1.55-.72-1.55l-1.88.11c-4.05,2.88-4.25,8.59-9.61,9.84a37.48,37.48,0,0,0-6.54,1.27c-11.54,3.88-30.45,15.62-40.73,16.51-10,.86-9.74-4.49-9.9-10.63C51.37,194.83,56.59,159.21,60.17,151.6Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "89.1651px 176.641px"
    },
    id: "elox0pca3hxg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.38,184.44,94,182.85s-1.55,1.6-1.09,6.76,3.42,7.26,3.42,7.26l-11.06,5.38Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "90.8px 192.55px"
    },
    id: "elac3r3896crr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5,184.56l-.43,2.1c-4.57,1.18-9.93,7.21-11,9.71C62.9,192.41,65.46,186.71,73.5,184.56Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "67.785px 190.465px"
    },
    id: "elbu2wck33tuj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,141.83s-1.45.14-4.28.58-6.91,1-10,5.78-3.3,6.9-5.08,15.17S51.59,190.83,51.2,198s.39,10.48,2.18,12,6,2.62,12.16.68S90,201.34,90,201.34s-2.36.15-3.11-6.83.82-10.44.82-10.44L73.5,186.28,78,167S84,148,75.8,141.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "70.5509px 176.774px"
    },
    id: "elwcafo3r5jac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elncxofrk3p0t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.8,141.83s-1.45.14-4.28.58-6.91,1-10,5.78-3.3,6.9-5.08,15.17S51.59,190.83,51.2,198s.39,10.48,2.18,12,6,2.62,12.16.68S90,201.34,90,201.34s-2.36.15-3.11-6.83.82-10.44.82-10.44L73.5,186.28,78,167S84,148,75.8,141.83Z",
    style: {
      opacity: 0.15,
      transformOrigin: "70.5509px 176.774px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnr6ef5zu1dj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5,186.28a15.71,15.71,0,0,0-11.23,9.19,14.08,14.08,0,0,1,11.82-11.72Z",
    style: {
      opacity: 0.15,
      transformOrigin: "68.18px 189.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122,172.82l-5.92-1.19,5.79.37A2.38,2.38,0,0,1,122,172.82Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "119.04px 172.225px"
    },
    id: "eldfn77xr4gwf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,176.86l-6.81-.88,6.82.09A3.5,3.5,0,0,1,125.63,176.86Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "122.239px 176.42px"
    },
    id: "elh20ftvw6ehi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.74,180.49a6.8,6.8,0,0,1-.91.26,22.11,22.11,0,0,1-2.37.16,2.64,2.64,0,0,1-.85,1.31,13.26,13.26,0,0,1-1.32,1.1l1.88-.11a2.94,2.94,0,0,1,1.93-1.11,1.4,1.4,0,0,1,.91.17,2.2,2.2,0,0,1,.7.75,1.75,1.75,0,0,0-.6-.89,1.35,1.35,0,0,0-.7-.28l.39-.83a4.58,4.58,0,0,0,1-.36,2.23,2.23,0,0,0,.92-.8A2.57,2.57,0,0,1,123.74,180.49Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "121.505px 181.59px"
    },
    id: "elbia3npqnwfv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-84",
    className: "animable",
    style: {
      transformOrigin: "101.96px 121.912px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-84",
    className: "animable",
    style: {
      transformOrigin: "101.96px 121.912px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--head--inject-84",
    className: "animable",
    style: {
      transformOrigin: "101.96px 121.912px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.78,125a6.68,6.68,0,0,1-6-2.29c-3.17-3.48-3.47-7-2-9.4,1.21-1.94,4.2-3.18,6.3-1.87,2.25,1.4,2.32,2.55,3.17,4.14s3,.34,2.28-6c4.36-2.05,3.66-9.35,6-12.32,3.68-4.67,9.75-3.46,11.72-2.37a7.91,7.91,0,0,1,8.26-.53c2.72,1.45,4.8,3.7,5.82,13.07.08.73-.46,2-.21,2.79,3.2,10-.62,19.59-3.29,22-1.83,1.69-5.24,2.83-9.31,2.6l0,4.36s11.74,12.24-3.23,11.13a23.49,23.49,0,0,1-17-9.6l-.1-17.53S89,124.55,86.78,125Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "100.634px 121.912px"
    },
    id: "elrcc80qohp6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26,123.17a3.34,3.34,0,0,1-6.55-1.3Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "108.961px 123.823px"
    },
    id: "elnta4k3qsexh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.69,123a3.33,3.33,0,0,0,2.65,2.83,3.13,3.13,0,0,0,1.18,0A3.38,3.38,0,0,0,105.69,123Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "107.605px 124.425px"
    },
    id: "elgr0894kb7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8,111.51a1.91,1.91,0,1,1-1.24-2.46A2,2,0,0,1,105.8,111.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.987px 110.876px"
    },
    id: "elt5oj5umneyc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,104.11,116,102a2.2,2.2,0,0,1,3-1A2.4,2.4,0,0,1,120,104.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.113px 102.431px"
    },
    id: "elhtrk8prpz6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53,111.11a1.91,1.91,0,1,0,1.11-2.52A1.95,1.95,0,0,0,116.53,111.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.303px 110.384px"
    },
    id: "eldn71cv5ey7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.21,102.57l-4.29,2.33a2.35,2.35,0,0,1,.89-3.29A2.57,2.57,0,0,1,102.21,102.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.8935px 103.108px"
    },
    id: "elfghnxdynfp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,105.16l-.85-.06c-2.77-.16-6.36-.09-8.48.65-2.66.92-3.55,1.86-5.05,1.93s-2.68-.78-5.63-1.45c-2.35-.54-6.18-.28-9.1.14l-.9.14a1.37,1.37,0,0,0-.92,1.51,3.4,3.4,0,0,0,1,1.66,2.07,2.07,0,0,1,.34.67A29.35,29.35,0,0,0,96.81,115a5.84,5.84,0,0,0,1.27,1.63,5,5,0,0,0,.63.48,3.07,3.07,0,0,0,.36.2,5.34,5.34,0,0,0,1.05.43l.17.05.28.06.28.06a8.5,8.5,0,0,0,.91.09l.39,0h.48c3.73-.15,5.18-2,6-3.77s.4-4.33,2.12-4.4h.17l.15,0c1.29.23,1.29,2.55,2.2,4.17a7,7,0,0,0,1.34,1.76,4,4,0,0,0,.31.27l.16.12.17.12.16.11.17.1.13.07.09,0a6,6,0,0,0,1.53.51l.14,0a8.09,8.09,0,0,0,1.82.1c3.49-.17,4.56-2.21,5-3.5a28.06,28.06,0,0,0,.75-4.74,1.47,1.47,0,0,1,.28-.63,3.13,3.13,0,0,0,.67-1.77A1.48,1.48,0,0,0,125,105.16Zm-17.44,7.45a5.11,5.11,0,0,1-1.13,2.53h0a5.24,5.24,0,0,1-4,1.59,4.72,4.72,0,0,1-4-1.63l-.14-.17-.12-.17a1.63,1.63,0,0,1-.11-.17l-.09-.14a.75.75,0,0,1-.07-.12l-.06-.1-.09-.18h0c-.09-.18-.16-.35-.23-.51h0c0-.11-.08-.21-.12-.31s-.12-.35-.16-.5l0-.09,0-.1c-.37-1.23-.87-3.66-.27-4.23s2.26-1.23,5-1.09h.3a10.92,10.92,0,0,1,1.28.16c.17,0,.34.06.5.09a10.64,10.64,0,0,1,1.27.34l.38.13.43.17.08,0,.16.08a2.63,2.63,0,0,1,.87.61C107.82,109.59,107.76,111.21,107.54,112.61Zm16.15-1.26c-.15,1-.47,3.1-2.35,4.1a4.88,4.88,0,0,1-2,.54,4.71,4.71,0,0,1-4.27-1.68l0,0-.08-.11a1,1,0,0,1-.09-.13l0-.07-.12-.19-.13-.22-.05-.11,0-.07,0-.09,0-.07a6.49,6.49,0,0,1-.33-.92c-.38-1.37-.63-3-.16-3.76s2.46-1.71,4.42-2a12.44,12.44,0,0,1,1.27-.15h1.12l.35,0,.65.08.15,0h0l.11,0,.15,0,.19,0,.31.1.06,0a2.68,2.68,0,0,1,.71.39C124.05,107.64,123.88,110.1,123.69,111.35Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "110.022px 111.515px"
    },
    id: "el04urwm4s9qdy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37,118l-6.78,2.84-1.43-8.63c.23-1.22.44-2.28,1.48-2.38Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "113.265px 115.335px"
    },
    id: "elaqzmas74elc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,111.05c0-.16-.08-.32-.13-.48l-.15,0-.27,0a2.9,2.9,0,0,0-.59,0c-.11,0-.14.14-.11.23a.27.27,0,0,0,.22.22l.54.08.25.05.05,0s0,0,0,0l.06,0A.3.3,0,0,0,122.37,111.05Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "121.74px 110.852px"
    },
    id: "elcnnlgmvtwbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,109.67a3.29,3.29,0,0,0,.44,0l.33-.07.19,0a6.16,6.16,0,0,1,.09-.72.33.33,0,0,0-.1,0l-.14,0-.28.07c-.24.07-.49.12-.73.21S120.85,109.68,121.1,109.67Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "121.47px 109.277px"
    },
    id: "el8tx558hyfyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.35,110.08a1,1,0,0,0,.25,0h.12l.27.05a5.05,5.05,0,0,1,.55.18.34.34,0,0,0,.34,0,.23.23,0,0,0,.06-.2l0-.07a.51.51,0,0,0-.09-.16,1.27,1.27,0,0,0-.4-.3l-.06,0-.06,0-.12,0-.26-.08a3.12,3.12,0,0,0-.44-.09,1.29,1.29,0,0,0-.39,0,.29.29,0,0,0-.16.15.31.31,0,0,0,0,.23A.5.5,0,0,0,99.35,110.08Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "99.9408px 109.875px"
    },
    id: "el3snv9gl7nax",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,111.67a.23.23,0,0,0,.06-.27.41.41,0,0,0-.23-.25,1.15,1.15,0,0,0-.17-.06h-.13a2.54,2.54,0,0,0-.39,0l-.16,0-.15,0h-.06a.7.7,0,0,0-.27.11l-.06.07,0,.09a.31.31,0,0,0,0,.23.55.55,0,0,0,.13.17.27.27,0,0,0,.1.06.3.3,0,0,0,.16.05h.3l.09,0,.18,0,.33-.06.07,0h0a.44.44,0,0,0,.15-.08h0Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "100.249px 111.476px"
    },
    id: "elzrrtcegag2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,120.83h0l-.13.07a1.12,1.12,0,0,0-.21.17l-.3.31a4.41,4.41,0,0,0-.5.72,2.56,2.56,0,0,0-.34.88c0,.14-.07.29-.09.44a1.49,1.49,0,0,0,0,.21.81.81,0,0,0,.06.31c0,.15.3.32.42.16a.63.63,0,0,0,.12-.21l.06-.18c0-.13.09-.27.15-.39s.22-.46.34-.69a4.38,4.38,0,0,1,.4-.62,4.64,4.64,0,0,0,.5-.69C105.51,121.11,105.21,120.73,105,120.83Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "104.454px 122.489px"
    },
    id: "el5zxc6pcnnd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.84,106.73l-9.77,4.68a10.21,10.21,0,0,1,1.51,1.21l8.51-3.86Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "90.08px 109.675px"
    },
    id: "el52weqlbczjy",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109.52,134.79c-5.85-.22-13.7-2.3-15.81-6.07,1.17,4.07,5.3,6.18,8.59,7.1a34.39,34.39,0,0,0,7.18,1.24Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "101.615px 132.89px"
    },
    id: "elzv3d0lf3u4l",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-84",
    className: "animable",
    style: {
      transformOrigin: "178.015px 80.104px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-84",
    className: "animable",
    style: {
      transformOrigin: "178.015px 80.104px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.69,75.47c0-16.35,18.5-29.61,41.33-29.61s41.32,13.26,41.32,29.61-18.5,29.61-41.32,29.61c-1.38,0-2.73,0-4.07-.15-4.52,8.48-12.19,9.94-18.16,9.27a11.2,11.2,0,0,0,6.38-11.38C147.21,98.36,136.69,87.8,136.69,75.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "178.015px 80.1014px"
    },
    id: "elhx3w3n4vak8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.74,114.62a.44.44,0,0,1-.38-.36.44.44,0,0,1,.25-.46,10.77,10.77,0,0,0,6.15-10.66c-15.5-4.71-25.5-15.54-25.5-27.67,0-16.56,18.73-30,41.76-30s41.75,13.48,41.75,30-18.73,30-41.75,30c-1.25,0-2.54-.05-3.83-.13a17.26,17.26,0,0,1-15.89,9.39A21.93,21.93,0,0,1,155.74,114.62ZM174,104.5c1.36.1,2.72.14,4,.14,22.55,0,40.89-13.08,40.89-29.17S200.57,46.3,178,46.3s-40.9,13.08-40.9,29.17c0,11.81,9.88,22.38,25.17,26.93a.44.44,0,0,1,.31.38,11.77,11.77,0,0,1-5.32,11.1c4.73.22,11.94-1,16.29-9.15a.43.43,0,0,1,.38-.23Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "178.015px 80.104px"
    },
    id: "elrdt38hmfxy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.84,76.31a4.2,4.2,0,1,0,4.2-4.2A4.2,4.2,0,0,0,191.84,76.31Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "196.04px 76.31px"
    },
    id: "elefxcd1jchkb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,76.31a4.21,4.21,0,1,0,4.21-4.2A4.2,4.2,0,0,0,173.81,76.31Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "178.02px 76.32px"
    },
    id: "elm3hxg2y9dyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.79,76.31a4.21,4.21,0,1,0,4.2-4.2A4.2,4.2,0,0,0,155.79,76.31Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "160px 76.32px"
    },
    id: "elungfzbcercn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb8wk9ov13nv"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "178.015px 76.32px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.84,76.31a4.2,4.2,0,1,0,4.2-4.2A4.2,4.2,0,0,0,191.84,76.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "196.04px 76.31px"
    },
    id: "el2fohgxj1bag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.81,76.31a4.21,4.21,0,1,0,4.21-4.2A4.2,4.2,0,0,0,173.81,76.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "178.02px 76.32px"
    },
    id: "eljipgbz9zwro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.79,76.31a4.21,4.21,0,1,0,4.2-4.2A4.2,4.2,0,0,0,155.79,76.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "160px 76.32px"
    },
    id: "el7nllsdtp3gd",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-planes--inject-84",
    className: "animable",
    style: {
      transformOrigin: "333.965px 120.059px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-84",
    className: "animable",
    style: {
      transformOrigin: "275.305px 161.635px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "358.71 189.88 335.59 170.47 324.02 172.6 358.71 189.88",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "341.365px 180.175px"
    },
    id: "elhcujbbmi1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9e390b2dry7"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "341.365px 180.175px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "358.71 189.88 335.59 170.47 324.02 172.6 358.71 189.88",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "341.365px 180.175px"
    },
    id: "el4rky0wc644j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "358.71 189.88 339.27 168.89 344.84 163.93 358.71 189.88",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "348.99px 176.905px"
    },
    id: "eljycfm1nolp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldt59njlh689"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "348.99px 176.905px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "358.71 189.88 339.27 168.89 344.84 163.93 358.71 189.88",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "348.99px 176.905px"
    },
    id: "el6wep2uxnno7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "339.27 168.89 338.73 173.11 358.71 189.88 339.27 168.89",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "348.72px 179.385px"
    },
    id: "elidip4ihcs3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhsfjapc84x8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "348.72px 179.385px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "339.27 168.89 338.73 173.11 358.71 189.88 339.27 168.89",
    id: "elci2b7b0hh4m",
    className: "animable",
    style: {
      transformOrigin: "348.72px 179.385px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,150.89l-.76-.65c.35-.4.71-.8,1.07-1.19l.73.68C193.35,150.11,193,150.5,192.66,150.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "192.8px 149.97px"
    },
    id: "el6ddwqr6m5ke",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.09,161.68c-.68-.78-1.39-1.55-2.11-2.29l.72-.7c.73.76,1.45,1.54,2.14,2.33Zm-71.1-3a6.71,6.71,0,0,1-1.53-.17l.21-1a6,6,0,0,0,2.86-.07l.28,1A6.45,6.45,0,0,1,259,158.68Zm66.76-1.46c-.76-.7-1.54-1.39-2.35-2.06l.64-.76c.82.68,1.62,1.38,2.38,2.08Zm-71.33,0a7.85,7.85,0,0,1-2.28-2.43l.86-.51a6.79,6.79,0,0,0,2,2.12Zm9.25-.53-.74-.68a5.9,5.9,0,0,0,1.35-2.53l1,.26A7,7,0,0,1,263.67,156.65ZM321,153.23c-.82-.62-1.67-1.23-2.53-1.82l.56-.82c.87.59,1.74,1.21,2.57,1.84Zm-69.74-1.7v-.27a8.43,8.43,0,0,1,.57-3l.94.36a7.32,7.32,0,0,0-.51,2.64v.23Zm13.19-1a7.17,7.17,0,0,0-.27-1,9,9,0,0,0-.82-1.72l.86-.52a10.74,10.74,0,0,1,.91,1.91,7.72,7.72,0,0,1,.3,1.17Zm51.4-.82c-.87-.53-1.78-1.06-2.7-1.57l.49-.88c.93.52,1.85,1.06,2.73,1.6Zm-119.92-2.18-.68-.74c.77-.71,1.57-1.41,2.39-2.08l.63.78C197.43,146.15,196.64,146.84,195.89,147.54Zm114.46-.84c-.92-.46-1.87-.9-2.82-1.32l.4-.92c1,.43,1.93.88,2.86,1.35ZM254.22,146l-.79-.62a13,13,0,0,1,2.35-2.27l.6.81A10.94,10.94,0,0,0,254.22,146Zm7.22-.58a20.94,20.94,0,0,0-2.33-2l.59-.8a23.12,23.12,0,0,1,2.45,2.08Zm43.21-1.29c-.95-.37-1.93-.73-2.93-1.07l.32-.95c1,.35,2,.72,3,1.09Zm-103.94-.55-.58-.82c.85-.61,1.74-1.2,2.64-1.75l.53.85C202.42,142.44,201.55,143,200.71,143.62ZM259,142.4l-.43-.9a22,22,0,0,1,3-1.17l.31.95A22.44,22.44,0,0,0,259,142.4Zm39.76-.25c-1-.3-2-.58-3-.83l.24-1c1,.26,2,.54,3,.84Zm-42.22-.4c-.87-.54-1.78-1.06-2.7-1.54l.47-.89c.94.5,1.86,1,2.76,1.58Zm36.17-1.13c-1-.21-2.05-.4-3.07-.56l.16-1c1,.17,2.08.36,3.11.57Zm-27.87-.13-.21-1c.8-.17,1.61-.32,2.42-.46l.7-.11.15,1-.69.11Q266,140.23,264.83,140.49ZM206,140.35l-.47-.88c.92-.49,1.87-1,2.84-1.41l.42.91C207.83,139.41,206.89,139.87,206,140.35Zm80.55-.73c-1-.12-2.07-.22-3.1-.3l.07-1c1.05.08,2.11.18,3.15.3Zm-15.56-.1-.1-1c1-.11,2.1-.2,3.15-.26l.06,1C273.06,139.32,272,139.41,271,139.52Zm9.34-.36c-1,0-2.07,0-3.12,0v-1c1.06,0,2.11,0,3.16,0ZM251,138.85c-.93-.42-1.9-.81-2.88-1.18l.35-.93c1,.37,2,.77,2.94,1.2Zm-39.39-1.08-.36-.93c1-.38,2-.73,3-1.05l.3,1C213.59,137.06,212.6,137.4,211.65,137.77Zm33.57-1.09c-1-.3-2-.58-3-.82l.24-1c1,.25,2.06.53,3.06.84Zm-27.65-.79-.24-1c1-.25,2-.48,3.09-.67l.19,1C219.59,135.42,218.57,135.64,217.57,135.89Zm21.6-.67c-1-.18-2-.34-3.08-.46l.12-1c1,.13,2.11.29,3.14.47Zm-15.49-.46-.12-1c1-.13,2.1-.23,3.16-.29l.06,1C225.74,134.54,224.7,134.63,223.68,134.76Zm9.31-.28c-1-.06-2.07-.09-3.1-.09v-1c1.05,0,2.12,0,3.16.09Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "263.045px 147.535px"
    },
    id: "el8psvy7rfnv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.05,165.39c-.3-.42-.62-.84-.94-1.25l.8-.61c.32.42.64.84.95,1.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "332.985px 164.46px"
    },
    id: "elgkmm6r7au46",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--paper-plane--inject-84",
    className: "animable",
    style: {
      transformOrigin: "354.475px 89.8387px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439.87 129.44 464.71 112.28 476.03 115.49 439.87 129.44",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "457.95px 120.86px"
    },
    id: "elmuiwhoslpxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleikv09dp46j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "457.95px 120.86px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439.87 129.44 464.71 112.28 476.03 115.49 439.87 129.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "457.95px 120.86px"
    },
    id: "elpoiqosbzp6",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "439.87 129.44 461.19 110.36 456.12 104.9 439.87 129.44",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "450.53px 117.17px"
    },
    id: "elv1k4kti56v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el20y53xaj8g9"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "450.53px 117.17px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "439.87 129.44 461.19 110.36 456.12 104.9 439.87 129.44",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.53px 117.17px"
    },
    id: "el4cmhpagobjg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "461.19 110.36 461.34 114.61 439.87 129.44 461.19 110.36",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "450.605px 119.9px"
    },
    id: "elmczslfdfqz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgaajznwrikr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "450.605px 119.9px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "461.19 110.36 461.34 114.61 439.87 129.44 461.19 110.36",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.605px 119.9px"
    },
    id: "eljg2l70tn62g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M233.35,57.66c-.17-.52-.31-1-.43-1.56l1-.23c.12.5.26,1,.41,1.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "233.625px 56.765px"
    },
    id: "elciqse2na54g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.41,103.08l-.88-.47a19.16,19.16,0,0,0,1.23-2.83l.95.32A20.75,20.75,0,0,1,469.41,103.08Zm2.15-6.1-1-.2A24.56,24.56,0,0,0,471,93.7l1,.08A24.64,24.64,0,0,1,471.56,97Zm-168.2-4.91c-.7,0-1.41,0-2.11,0l0-1c1.05,0,2.1,0,3.15,0l0,1Zm4.28-.11-.05-1c1.05,0,2.1-.13,3.15-.22l.08,1C309.76,91.83,308.7,91.91,307.64,92Zm-9.58-.06c-1.06-.07-2.12-.17-3.18-.28l.11-1c1,.11,2.09.2,3.14.27ZM314,91.4l-.13-1c1.05-.13,2.09-.28,3.13-.45l.16,1C316.11,91.12,315.05,91.27,314,91.4Zm-22.29-.18c-1.07-.16-2.12-.32-3.14-.49l.16-1c1,.17,2.06.33,3.13.48Zm179.35-.63a21.27,21.27,0,0,0-.39-3.07l1-.2a21.78,21.78,0,0,1,.41,3.22ZM320.3,90.4l-.19-1c1-.2,2.06-.42,3.09-.65l.22,1Q321.86,90.1,320.3,90.4Zm-34.87-.2-3.12-.6.19-1c1,.2,2,.4,3.11.59ZM326.52,89l-.25-1c1-.26,2-.54,3.05-.83l.28,1C328.58,88.44,327.55,88.73,326.52,89Zm-47.33,0c-1.07-.23-2.1-.47-3.1-.72l.24-1,3.08.72ZM273,87.41c-1.06-.29-2.08-.59-3.06-.89l.29-1c1,.3,2,.6,3,.89Zm59.64-.19-.31-1c1-.32,2-.66,3-1l.33.95C334.67,86.56,333.66,86.9,332.65,87.22Zm-65.73-1.69c-1.05-.36-2.05-.73-3-1.1l.36-.93c1,.36,1.93.73,3,1.08Zm71.75-.41-.36-.94c1-.37,2-.75,2.95-1.15l.37.92C340.65,84.35,339.66,84.74,338.67,85.12Zm131.1-.54A11.64,11.64,0,0,0,468.24,82l.78-.62a12.5,12.5,0,0,1,1.67,2.84ZM261,83.21c-1-.44-2-.89-2.89-1.36l.45-.9c.92.47,1.88.91,2.84,1.34Zm83.6-.49-.4-.92c1-.42,1.93-.85,2.89-1.29l.42.91C346.51,81.86,345.54,82.3,344.57,82.72Zm-89.32-2.38c-.92-.53-1.84-1.09-2.73-1.67l.55-.84c.87.57,1.77,1.12,2.68,1.64Zm95.11-.29-.44-.89.31-.16c.76-.37,1.59-.81,2.47-1.31l.49.87c-.89.51-1.74,1-2.52,1.34Zm115.78-.37a26.79,26.79,0,0,0-2.38-2l.6-.81A29,29,0,0,1,466.83,79ZM355.93,76.9l-.53-.84c.87-.55,1.75-1.14,2.63-1.75l.57.83C357.71,75.75,356.82,76.34,355.93,76.9Zm-106-.06c-.84-.62-1.66-1.27-2.52-2l.64-.77c.85.7,1.65,1.34,2.47,2ZM461.17,76c-.89-.51-1.82-1-2.78-1.42l.4-.91a29.87,29.87,0,0,1,2.88,1.46ZM379,75.84c-.77,0-1.54,0-2.3,0l0-1c1.06,0,2.11,0,3.15,0l0,1Zm4.09-.11-.05-1q1.62-.09,3.15-.21l.08,1C385.27,75.61,384.21,75.68,383.12,75.73Zm-9.59-.14c-1.12-.11-2.19-.25-3.19-.43l.18-1c1,.18,2,.32,3.1.43Zm15.94-.34-.09-1,3.15-.32.1,1Zm6.32-.63-.1-1,3.16-.33.1,1Zm-28.59-.2a22.09,22.09,0,0,1-3-1.13l.42-.91a20.1,20.1,0,0,0,2.9,1.09ZM402.11,74,402,73l3.16-.33.1,1Zm53.37-.56c-1-.33-2-.63-3-.89l.24-1c1.06.27,2.1.58,3.09.91Zm-47.06-.1-.1-1,3.16-.33.1,1Zm-47.23,0-.6-.8c.87-.66,1.7-1.32,2.47-2l.64.77C362.92,71.93,362.08,72.6,361.19,73.27ZM245,72.78l-1.11-1c-.43-.37-.85-.75-1.27-1.13l.68-.74c.41.38.83.75,1.25,1.12l1.11,1Zm169.77-.13-.1-1,3.16-.31.1,1Zm6.32-.62-.1-1,3.17-.29.09,1Zm28.34-.17c-1-.18-2-.34-3.11-.46l.12-1c1.09.13,2.16.29,3.17.47Zm-88.06-.23A12.86,12.86,0,0,1,359,69.36l.78-.63a11.89,11.89,0,0,0,2.2,2.1Zm66-.18-.09-1,1.47-.13,1.71-.13.07,1-1.7.13Zm15.78-.35c-1-.06-2.09-.11-3.15-.14l0-1c1.08,0,2.16.08,3.19.15ZM433.69,71l0-1c1.08,0,2.14-.07,3.19-.08v1C435.81,71,434.76,71,433.69,71Zm-67.6-1.9-.7-.71c.33-.33.65-.66.94-1a10,10,0,0,0,1-1.35l.85.53a10.6,10.6,0,0,1-1.13,1.49C366.77,68.43,366.44,68.77,366.09,69.12Zm-125.8-.69c-.77-.8-1.49-1.61-2.14-2.4l.77-.63c.64.77,1.34,1.55,2.09,2.34Zm117-1.91a12.74,12.74,0,0,1-.81-2.67l-.09-.49,1-.15c0,.15.05.3.08.45a12.23,12.23,0,0,0,.75,2.47Zm12.32-2.88-1-.32a13.89,13.89,0,0,0,.66-3l1,.11A15.26,15.26,0,0,1,369.6,63.64Zm-133.38-.19a27.66,27.66,0,0,1-1.63-2.79l.9-.45a23.42,23.42,0,0,0,1.57,2.69Zm121.11-3.27-1-.12a12.67,12.67,0,0,1,.81-3.19l.93.36A12.16,12.16,0,0,0,357.33,60.18Zm12-2.91a11.06,11.06,0,0,0-.75-2.93l.93-.38a12.12,12.12,0,0,1,.81,3.2Zm-9.79-2.71-.81-.58a13,13,0,0,1,2.05-2.26l.2-.17.62.79-.16.13A12.17,12.17,0,0,0,359.52,54.56ZM366.88,52a4.13,4.13,0,0,0-2.68-.75l-.06-1a5.12,5.12,0,0,1,3.32.93Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.34px 76.6587px"
    },
    id: "el2xccxt8c8n5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.29,107.06l-.64-.77a9.6,9.6,0,0,0,1.07-1.05l.75.66A9.91,9.91,0,0,1,466.29,107.06Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "466.56px 106.15px"
    },
    id: "el0vu26ydeail",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonAnimate);
export default __webpack_public_path__ + "static/media/lesson-animate.245e9ade5eb907f31b56272f8de81948.svg";
export { ForwardRef as ReactComponent };